import moment from 'moment';
import crypto from 'crypto-js';
import { cloneDeep, drop } from 'lodash';
import { v4 as uuidv4} from 'uuid';
import { matchPath } from 'react-router';
import Constant from '../constant/Constant';
import systemField from '../constant/SystemField';
import UserLogConstant from '../constant/UserLogConstant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { getCorporationById } from '@/service/organizationService';
import { uploadFileHtmlToS3, uploadFileScriptToS3, uploadFileToS3WithContentType } from '../../service/s3Service';
import {
    isShowFieldAIPDFPageSplitStatus,
    isShowFieldEventTypeChatThread,
    isShowReasoningEffortField
} from '../../component/ticketList/handler/KnowledgeTicketHandler';
import { getPublicAPI } from '@/service/publicService';
import sessionStorageUtil from '@/common/utils/sessionStorageUtil';
import Logger from '@/common/utils/Logger';
import TelephoneConstant from '../constant/TelephoneConstant';
import { LOCAL_MCP_LABEL_PREFIX } from '@/component/mcpCatalog/McpCatalogConstant';
import { tr, trLabel } from '@/common/utils/tr';
import trI18n from '@/common/utils/trI18n';

const moment_timezone = require('moment-timezone');
const CryptoJS = require("crypto-js");
const encodeKey = "accelaBaDesk";

const cleanPhone = (value) => {
    if (!value) return '';
    return String(value)
        .trim()
        .replace(/\u200B|\uFEFF/g, '') // zero-width chars
        .replace(/\D/g, ''); // remove non-digits
};

const addPlusToPhoneNumber = number => {
    if (typeof number !== 'string') return `${number}`;
    return number.startsWith('+') ? number : `+${number}`;
};

const getThumbnailPaths = (originalPath, extractSize = []) => {
    if (!originalPath || typeof originalPath !== 'string') {
        return {};
    }

    const lastDotIndex = originalPath.lastIndexOf('.');
    if (lastDotIndex === -1) {
        return {};
    }

    const basePath = originalPath.substring(0, lastDotIndex);
    const ext = originalPath.substring(lastDotIndex);

    const allSizes = {
        small: `${basePath}_thumbnail_small${ext}`,
        medium: `${basePath}_thumbnail_medium${ext}`,
        large: `${basePath}_thumbnail_large${ext}`,
    };

    if (!isEmptyArray(extractSize)) {
        const result = {};
        extractSize.forEach(size => {
            if (allSizes[size]) {
                result[size] = allSizes[size];
            }
        });
        return result;
    }

    return allSizes;
}

function normalizeFileData(file) {
    if (!file) return {};
    return {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
        lastModified: file.lastModified
    };
}



const isImageFile = fileName => {
    if (isEmptyString(fileName)) {
        return false;
    }
    return /\.(jpe?g|tiff?|png|jpg|webp|bmp|gif|jpe|jfif)$/i.test(fileName);
};

const isJson = str => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

const isObjectType = obj => {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        !Array.isArray(obj) &&
        Object.prototype.toString.call(obj) === '[object Object]'
    );
}

const isNotEmptyObj = obj => {
    return isObjectType(obj) && Object.keys(obj).length > 0;
}

const convertJSONDataToObject = data => {
    if (isEmptyObject(data) || isEmptyString(data)) {
        return {};
    }

    if (isEmptyArray(data)) {
        return [];
    }

    if (isJson(data)) {
        return JSON.parse(data);
    }
    return data;
};

const getUrlParameter = name => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const getTextByLanguage = (language, strName) => {
    try {
        if (isEmptyObject(strName) || isEmptyString(strName) || isEmptyString(language)) {
            return '';
        }
        strName = typeof strName === 'object' ? JSON.stringify(strName) : strName;
        let objName = Utils.convertJSONDataToObject(strName);
        return getValueString(objName[`${language}`]?.text);
    } catch (err) {
        console.log('getTextByLanguage :>> ', err);
    }
};

const getCorporationName = (language, corporationDetail) => {
    let strName = corporationDetail?.name;

    try {
        if (isEmptyObject(strName) || isEmptyString(strName) || isEmptyString(language)) {
            return '';
        }
        strName = typeof strName === 'object' ? JSON.stringify(strName) : strName;
        let objName = Utils.convertJSONDataToObject(strName);
        let orgName = getValueString(objName[`${language}`]?.text);
        if (corporationDetail.active === Constant.CORPORATION_ACTIVE.BLOCK) {
            orgName = `${orgName} (${Constant.SUFFIX_TEXT.BLOCK_CORPORATION})`;
        }
        if (corporationDetail.active === Constant.CORPORATION_ACTIVE.DELETED) {
            orgName = `${orgName} (${Constant.SUFFIX_TEXT.DELETED_CORPORATION})`;
        }
        return orgName;
    } catch (err) {
        console.log('getTextByLanguage :>> ', err);
    }
};

const getGuestContractUrlParameter = () => {
    let validUrl = isCreateGuestContractUrl();
    if (!validUrl) {
        return null;
    }
    let data = window.location.pathname.replace(Constant.CREATE_GUEST_CONTRACT_ROUTER, '');
    return data;
};

const isCreateGuestContractUrl = () => {
    if (!window.location.pathname.startsWith(Constant.CREATE_GUEST_CONTRACT_ROUTER)) {
        return false;
    }
    let paramCreateGuestContract = window.location.pathname.replace(
        Constant.CREATE_GUEST_CONTRACT_ROUTER,
        ''
    );
    if (paramCreateGuestContract.indexOf('/') >= 0) {
        return false;
    }
    return true;
};

const isApprovePageUrl = () => {
    if (!window.location.pathname.startsWith(Constant.APPROVE_PAGE_ROUTER)) {
        return false;
    }
    let paramApprove = window.location.pathname.replace(Constant.APPROVE_PAGE_ROUTER, '');
    if (paramApprove.indexOf('/') >= 0) {
        return false;
    }
    return true;
};

const isConfirmCreateOrgPageUrl = () => {
    if (!window.location.pathname.startsWith(Constant.CONFIRM_CREATE_ORGANIZATION_ROUTER)) {
        return false;
    }
    let paramApprove = window.location.pathname.replace(
        Constant.CONFIRM_CREATE_ORGANIZATION_ROUTER,
        ''
    );
    if (paramApprove.indexOf('/') >= 0) {
        return false;
    }
    return true;
};

const isConfirmCreateGuestOrgPageUrl = () => {
    if (!window.location.pathname.startsWith(Constant.CONFIRM_CREATE_GUEST_CONTRACT_ROUTER)) {
        return false;
    }
    let paramApprove = window.location.pathname.replace(
        Constant.CONFIRM_CREATE_GUEST_CONTRACT_ROUTER,
        ''
    );
    if (paramApprove.indexOf('/') >= 0) {
        return false;
    }
    return true;
};

const isLoginPageUrl = () => {
    let pathName = window.location.pathname;
    if (pathName.startsWith(Constant.LOGIN_ROUTER)) {
        return true;
    }
    return false;
};

const isEmptyString = str => {
    return typeof str === 'undefined' || str === null || str === '';
};

/**
 * Count characters in string (treats half-width and full-width equally)
 * @param {string} str - Input string
 * @returns {number} Character count
 */
const countCharacters = str => {
    if (!str || typeof str !== 'string') {
        return 0;
    }
    // Simply count all characters regardless of width
    return str.length;
};

const isEmptyObject = obj => {
    return (
        typeof obj === 'undefined' ||
        obj === null ||
        (Object.keys(obj).length === 0 && obj.constructor === Object)
    );
};

const readFileAsArrayBuffer = file => {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = () => {
            resolve(reader);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
};

const isEmptyArray = arr => {
    return typeof arr === 'undefined' || arr === null || arr.length === 0 || isEmptyObject(arr);
};

const getUserType = userType => {
    if (typeof userType === 'undefined' || userType === null) {
        return '';
    }
    let type;
    switch (userType) {
        case Constant.USER_TYPE.CUSTOMER:
            type = trI18n('CUSTOMER_USER');
            break;
        case Constant.USER_TYPE.GENERAL:
            type = trI18n('GENERAL_USER');
            break;
        case Constant.USER_TYPE.INTERNAL:
            type = trI18n('INTERNAL_USER');
            break;
        default:
            type = '';
    }
    return type;
};

const getTimeToDateNow = dateTimeInput => {
    const now = moment(new Date()); //todays date
    const createTime = moment(dateTimeInput);
    const duration = moment.duration(now.diff(createTime));

    const days = duration.asDays();
    const day = Math.trunc(days);

    const hours = (days - day) * 24;
    const hour = Math.trunc(hours);

    const minute = Math.trunc((hours - hour) * 60);

    return { day, hour, minute };
};

const sortByCreatedAtDesc = arr => {
    if (isEmptyArray(arr)) {
        return [];
    }
    return arr.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
    });
};

const sortByCreatedAtAsc = arr => {
    if (isEmptyArray(arr)) {
        return [];
    }
    return arr.sort((a, b) => {
        return new Date(a.createdAt) - new Date(b.createdAt);
    });
};

const sortByUpdatedAtDesc = arr => {
    if (isEmptyArray(arr)) {
        return [];
    }
    return arr.sort((a, b) => {
        return new Date(b.updatedAt) - new Date(a.updatedAt);
    });
};

const sortByUpdatedAtAsc = arr => {
    if (isEmptyArray(arr)) {
        return [];
    }
    return arr.sort((a, b) => {
        return new Date(a.updatedAt) - new Date(b.updatedAt);
    });
};

const sortByDeletedAtAsc = arr => {
    if (isEmptyArray(arr)) {
        return [];
    }
    return arr.sort((a, b) => {
        return new Date(a.deletedAt) - new Date(b.deletedAt);
    });
};

const sortByDrillDownLabelAsc = (arr, locale = '') => {
    if (isEmptyArray(arr)) {
        return [];
    }
    if (locale) {
        return arr.sort((a, b) => {
            return a.label.localeCompare(b.label, 'ja-JP', {
                numeric: true
            });
        });
    }
    return arr.sort((a, b) => {
        return a.label.localeCompare(b.label);
    });
};

const sortByHitNumberDesc = arr => {
    if (isEmptyArray(arr)) {
        return [];
    }
    return arr.sort((a, b) => {
        const hitA = a?.total || 0;
        const hitB = b?.total || 0;
        if (hitB !== hitA) return hitB - hitA;
        return a.no - b.no;
    });
};

const sortDrillDownByNo = arr => {
    if (isEmptyArray(arr)) {
        return [];
    }
    return arr.sort((a, b) => {
        return a.no - b.no;
    });
}

const isValidJSONString = str => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

const isValidJSONObject = (str) => {
    if (typeof str !== 'string') return false;

    try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
    } catch {
        return false;
    }
};

const getCorporationIdFromContentId = contentId => {
    let corporationId = '';
    if (!isEmptyString(contentId)) {
        const arrContentId = contentId.split('-');
        if (!isEmptyArray(arrContentId) && arrContentId.length > 2) {
            arrContentId.pop(); //remove counter
            arrContentId.pop(); //remove userNo
            if (!isEmptyArray(arrContentId)) {
                corporationId = arrContentId.join('-');
            }
        }
    }

    return corporationId;
};

const getDateTimeByFormatJapanYYYY_MM_DDHHMM = dateTimeString => {
    if (!dateTimeString) return '';
    let dateTime = new Date(dateTimeString);
    ///
    let monthInt = dateTime.getMonth() + 1;
    let month = monthInt < 10 ? `0${monthInt}` : monthInt;
    let day = dateTime.getDate() < 10 ? `0${dateTime.getDate()}` : dateTime.getDate();
    let hours = dateTime.getHours() < 10 ? `0${dateTime.getHours()}` : dateTime.getHours();
    let minutes = dateTime.getMinutes() < 10 ? `0${dateTime.getMinutes()}` : dateTime.getMinutes();

    return `${dateTime.getFullYear()}/${month}/${day} ${hours}:${minutes}`;
};

const getDateTimeByFormatYYYYMMDDHHMM = dateTimeString => {
    if (!dateTimeString) return '';
    let dateTime = new Date(dateTimeString);
    let monthInt = dateTime.getMonth() + 1;
    let month = monthInt < 10 ? `0${monthInt}` : monthInt;
    let day = dateTime.getDate() < 10 ? `0${dateTime.getDate()}` : dateTime.getDate();
    let hours = dateTime.getHours() < 10 ? `0${dateTime.getHours()}` : dateTime.getHours();
    let minutes = dateTime.getMinutes() < 10 ? `0${dateTime.getMinutes()}` : dateTime.getMinutes();

    return `${dateTime.getFullYear()}/${month}/${day} ${hours}:${minutes}`;
};

const formatDateTime = (
    dateTimeString,
    format = 'YYYY/MM/DD HH:mm',
    tz = 'Asia/Tokyo',
) => {
    const dateTime = moment_timezone.utc(dateTimeString).tz(tz);
    return dateTime.format(format);
};

const getDateTimeByFormatYYYYMMDDHHMMSS = dateTimeString => {
    if (!dateTimeString) return '';
    let dateTime = new Date(dateTimeString);
    let monthInt = dateTime.getMonth() + 1;
    let month = monthInt < 10 ? `0${monthInt}` : monthInt;
    let day = dateTime.getDate() < 10 ? `0${dateTime.getDate()}` : dateTime.getDate();
    let hours = dateTime.getHours() < 10 ? `0${dateTime.getHours()}` : dateTime.getHours();
    let minutes = dateTime.getMinutes() < 10 ? `0${dateTime.getMinutes()}` : dateTime.getMinutes();
    let seconds = dateTime.getSeconds() < 10 ? `0${dateTime.getSeconds()}` : dateTime.getSeconds();

    return `${dateTime.getFullYear()}/${month}/${day} ${hours}:${minutes}:${seconds}`;
};

const isIsoDateTimeString = s => {
    if (typeof s !== 'string') return false;

    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;

    if (!isoRegex.test(s)) return false;

    const t = Date.parse(s);
    return Number.isFinite(t);
};

const formatIfDateTimeString = value => {
    if (!value) return value;
    if (isIsoDateTimeString(value.trim())) return getDateTimeByFormatYYYYMMDDHHMMSS(value.trim());
    return value;
};

const getDateByFormatYYYY_MM_DD = dateTimeString => {
    let dateTime = new Date(dateTimeString);
    let month = `${dateTime.getMonth() + 1}`;
    let day = `${dateTime.getDate()}`;
    if (month.length < 2) {
        month = `0${month}`;
    }
    if (day.length < 2) {
        day = `0${day}`;
    }
    return `${dateTime.getFullYear()}/${month}/${day}`;
};

const reducerDataList = (state, action) => {
    switch (action.type) {
        case Constant.ACTION_CHANGE_LIST_DATA_TYPE.INITIAL:
            return action.posts;
        case Constant.ACTION_CHANGE_LIST_DATA_TYPE.ADD:
            return [...state, ...action.posts];
        case Constant.ACTION_CHANGE_LIST_DATA_TYPE.PUSH:
            if (action?.post?.id && state.some(p => p?.id === action?.post?.id)) {
                return state;
            }
            return [action.post, ...state];
        case Constant.ACTION_CHANGE_LIST_DATA_TYPE.REPLACE:
            state.splice(action.postIndex, 1, action.newPost);
            return state;
        case Constant.ACTION_CHANGE_LIST_DATA_TYPE.CONCAT:
            state = state.concat(action.posts);
            return state;
        default:
            return state;
    }
};

const validateEmail = email => {
    if (isEmptyString(email)) {
        return false;
    }
    const re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
    return re.test(email);
};

const validateEmailVer2 = email => {
    if (!email) {
        return false; // Email address cannot be empty
    }

    // Do not allow special characters like ~!#$%^&(),<> or icons in the local part
    const specialCharPattern = /[~!#$%^&(),<>]/;
    if (specialCharPattern.test(email)) {
        return false; // Email contains invalid special characters
    }

    // Split local part and domain by the "@" symbol
    const emailParts = email.split("@");
    if (emailParts.length !== 2) {
        return false; // Email must contain exactly one "@" symbol
    }

    const [localPart, domainPart] = emailParts;

    // Ensure no consecutive special characters and special characters are not at the start or end
    const localPartPattern = /^[a-zA-Z0-9]+([._+-]?[a-zA-Z0-9]+)*$/;
    if (!localPartPattern.test(localPart)) {
        return false; // Local part has consecutive special characters or starts/ends with them
    }

    // Do not allow ".." in the email
    if (email.includes("..", "--", "__", "++")) {
        return false; // Email cannot contain consecutive dots
    }

    // Validate the domain part to allow multiple subdomains (e.g., gaugau.dbdesk-dev.ominext.dev)
    const domainPattern = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    if (!domainPattern.test(domainPart)) {
        return false; // Domain is not valid
    }

    // Do not allow "-" before or after "@"
    if (/[-]$/.test(localPart) || /^-/.test(domainPart)) {
        return false; // "-" cannot appear before or after "@"
    }

    // Check "." at the beginning or end of the domain part
    if (/^\./.test(domainPart) || /\.$/.test(domainPart)) {
        return false; // Domain cannot start or end with "."
    }

    return true; // Email is valid
};

/**
 * Check if email matches the fake phone user email pattern
 * Pattern: {projectId}_{phoneNumber}@fake.com
 * @param {string} email - Email address to check
 * @returns {boolean} True if email matches fake phone user pattern
 */
const isFakePhoneUserEmail = email => {
    if (!email || typeof email !== 'string') {
        return false;
    }
    const originMail = getDisplayUserEmailWithoutSuffix(email);
    // Pattern: projectId_phoneNumber@fake.com
    // projectId can contain letters, numbers, and hyphens
    // phoneNumber should be digits only
    // Domain must be exactly @fake.com
    const fakeEmailPattern = /^.+@fake\.com$/i;
    return fakeEmailPattern.test(originMail.trim());
};

const getMenuSelectedByUrl = (defaultMenu, userId) => {
    let currentLocation = window.location;
    let menuType = '';
    switch (currentLocation.pathname) {
        case Constant.USER_MANAGEMENT_ROUTER:
            menuType = Constant.MENU_SELECT_TYPE.SYSTEM;
            break;
        case Constant.UPDATE_ORG_PROFILE_ROUTER:
            menuType = Constant.MENU_SELECT_TYPE.SYSTEM;
            break;
        case Constant.PROJECT_MANAGEMENT_ROUTER:
            menuType = Constant.MENU_SELECT_TYPE.SYSTEM;
            break;
        case `${Constant.USER_PROFILE_ROUTER}/${userId}`:
            menuType = Constant.MENU_SELECT_TYPE.USER_PROFILE;
            break;
        case `${Constant.PROJECT_USER_MANAGEMENT_ROUTER}`:
            menuType = Constant.MENU_SELECT_TYPE.PROJECT_SETTING;
            break;
        default:
            menuType = defaultMenu;
    }
    return menuType;
};

const isProjectManagerOfProject = (project, projectManagerList) => {
    if (!project || !projectManagerList || !projectManagerList.length) {
        return false;
    }
    if (projectManagerList.indexOf(project) > -1) {
        return true;
    }
    return false;
};

const getCloudFrontUrlForCorporationLogo = params => {
    let filename = params?.corporationDetail?.logoFileName;

    if (isEmptyString(params.image) || !filename) {
        return Constant.LOGO_DEFAULT;
    }
    let s3Key = params.image + '/' + filename;
    // if (params?.corporationDetail && params?.corporationDetail?.updatedAt) {
    //     const updatedAt = new Date(params?.corporationDetail?.updatedAt);
    //     const lastReleaseDate = new Date("2023-03-27");
    //     s3Key = params.image;
    // }

    const expiryTime = new Date().getTime() + Constant.S3_URL_EXPIRY_TIME * 60000;
    let paramsUrlObj = {
        expiryTime: expiryTime,
        keyFile: `/public/${s3Key}`,
        publicAll: true
    };
    if (params.type === Constant.S3_FILE_TYPE.CORPORATION_LOGO_PROFILE_FILE) {
        paramsUrlObj.type = Constant.S3_FILE_TYPE.CORPORATION_LOGO_LOGIN_FILE;
        paramsUrlObj.currentCorporationId = params.corporationDetail.id;
        paramsUrlObj.corporationId = params.organizationDomain;
    }
    const paramsUrl = encodeURIComponent(
        crypto.AES.encrypt(JSON.stringify(paramsUrlObj), Constant.S3_URL_AES_ENCODE_KEY).toString()
    );
    return `${process.env.REACT_APP_CLOUD_FRONT_URL}/${paramsUrl}`;
};

const getCloudFrontUrlOfFilePublicAll = (s3Key, options = {}) => {
    const { noExpiry = false, noCache = false } = options;
    const expiryTime = noExpiry ? null : 604800;

    let paramsUrlObj = {
        keyFile: s3Key,
        publicAll: true
    };

    if (expiryTime) {
        paramsUrlObj.expiryTime = expiryTime;
    }
    
    if (noCache) {
        paramsUrlObj = {
            ...paramsUrlObj,
            noCache: true
        };
    }

    const paramsUrl = encodeURIComponent(
        crypto.AES.encrypt(JSON.stringify(paramsUrlObj), Constant.S3_URL_AES_ENCODE_KEY).toString()
    );
    return `${process.env.REACT_APP_CLOUD_FRONT_URL}/${paramsUrl}`;
};

const getLinkDownloadFileFromS3 = (keyFile, affiliationOrganization) => {
    let uriObj = { publicAll: true, keyFile: `/${keyFile}`, affiliationOrganization: affiliationOrganization };
    const enCodeUriObj = encodeURIComponent(
        CryptoJS.AES.encrypt(JSON.stringify(uriObj), encodeKey).toString()
    );
    const newUri = `/${enCodeUriObj}`;
    return newUri;
};

const isEmpty = data => {
    return data === undefined || data === null;
};

const getValueString = str => {
    if (str) {
        return str?.toString();
    }
    return '';
};

const getPrefixOfId = id => {
    try {
        if (!id || isEmptyString(id)) {
            return '';
        }
        const strArray = id.split('_');
        return strArray[0];
    } catch (error) {
        Logger.error('getPrefixOfId error', { id, error });
        return '';
    }
};

/**
 * Check admin user
 * @param {*} user
 * @returns isAdmin
 */
export const isAdminUser = user => {
    return (
        !Utils.isEmptyObject(user) &&
        (Constant.PRIVILEGE_USER.ADMIN_OWNER === user.privilege ||
            Constant.PRIVILEGE_USER.ADMIN === user.privilege)
    );
};

/**
 * Get type of user
 * @param {*} user
 * @returns user Type
 */
export const getTypeUser = userDetail => {
    if (isEmptyObject(userDetail)) {
        return '';
    }
    if (!userDetail.type) {
        return '';
    }
    return userDetail.type;
};

/**
 * Get full name of user
 * @param {*} language
 * @param {*} userDetail
 * @returns fullName of user
 */
export const getFullNameOfUser = (language, userDetail, noSpace) => {
    if (isEmptyString(language) || isEmptyObject(userDetail)) {
        return '';
    }
    let spaceBetween = ' ';
    if (noSpace) {
        spaceBetween = '';
    }
    let fullName = `${getTextByLanguage(
        language,
        userDetail.lastName
    )}${spaceBetween}${getTextByLanguage(language, userDetail.firstName)}`;

    return fullName?.toString();
};

const getFullNameOfUserWithActiveStatus = (language, userDetail) => {
    if (isEmptyString(language) || isEmptyObject(userDetail)) {
        return '';
    }
    let fullName = `${getTextByLanguage(language, userDetail.lastName)} ${getTextByLanguage(language, userDetail.firstName)}`;
    fullName = fullName ? fullName.trim() : fullName;

    if (userDetail.active === Constant.ACTIVE_FLAG.DELETED) {
        fullName = `${fullName} (${Constant.SUFFIX_TEXT.DELETED_USER})`;
    }
    
    return fullName;
};

const displayB2cUserOnMessageVoice = (postDetail) => {
    const fullName = getFullNameOfUser(
        Constant.LANGUAGE_TYPE.JP,
        postDetail.userDetailPostMsg
    );

    const organizationName = postDetail.userDetailPostMsg?.organizationName;
    const userPhoneNumber = postDetail.userDetailPostMsg?.tel ? `+${postDetail.userDetailPostMsg?.tel}` : '';

    return [fullName, organizationName, userPhoneNumber]
        .filter(Boolean)
        .join(' ');
}


const getDisplayUserNameMsgVoice = (postDetail, ticketInfo) => {
    if (Utils.isAppIntegrationTicket(ticketInfo) && postDetail.role === TelephoneConstant.MSG_VOICE_ROLE.CUSTOMER) {
        return TelephoneConstant.CUSTOMER.LABEL;
    }

    if (postDetail.chatThreadType !== Constant.THREAD_TYPE.CUSTOMER) {
        return getFullNameOfUserWithCorporationStatus(
            Constant.LANGUAGE_TYPE.JP,
            postDetail.userDetailPostMsg,
            '',
            ticketInfo
        );
    }

    const userDetailPostMsg = postDetail.userDetailPostMsg;
    if (userDetailPostMsg.type === Constant.USER_TYPE.CUSTOMER) {
        return displayB2cUserOnMessageVoice(postDetail);
    }

    return getFullNameOfUserWithCorporationStatus(
        Constant.LANGUAGE_TYPE.JP,
        postDetail.userDetailPostMsg,
        '',
        ticketInfo
    );
}

/**
 * Get full name of user
 * @param {*} language
 * @param {*} userDetail
 * @returns fullName of user
 */
export const getFullNameOfUserWithCorporationStatus = (
    language,
    userDetail,
    noSpace,
    ticketInfo
) => {
    let listBlockedOrg = ticketInfo.listBlockedOrg;
    let listDeleteOrg = ticketInfo.listDeletedOrg;
    if (userDetail?.id?.includes('anonymous_')) {
        userDetail.firstName = '{"jp":{"A":"F","text":"未登録カスタマー"}}';
    }
    if (isEmptyString(language) || isEmptyObject(userDetail)) {
        return '';
    }
    let spaceBetween = ' ';
    if (noSpace) {
        spaceBetween = '';
    }
    let fullName = `${getTextByLanguage(
        language,
        userDetail.lastName
    )}${spaceBetween}${getTextByLanguage(language, userDetail.firstName)}`;
    let nameOfUser = fullName?.toString();
    if (listBlockedOrg?.includes(userDetail.affiliationOrganization)) {
        nameOfUser = `${nameOfUser} (${Constant.SUFFIX_TEXT.BLOCK_CORPORATION})`;
    }
    if (listDeleteOrg?.includes(userDetail.affiliationOrganization)) {
        nameOfUser = `${nameOfUser} (${Constant.SUFFIX_TEXT.DELETED_CORPORATION})`;
    }
    return nameOfUser;
};

/**
 * Find index in array by id
 * @param {*} id
 * @param {*} arr
 * @returns index
 */
export const findIndexInArrayById = (id, arr) => {
    if (isEmptyArray(arr)) return -1;
    let index = arr.findIndex((item, i) => {
        return item.id === id;
    });
    return index === undefined || index === null ? -1 : index;
};

export const findObjectById = (id, arr) => {
    if (Utils.isEmptyArray(arr)) {
        return null;
    } else {
        let obj = arr.find(item => {
            return item.id === id;
        });
        return Utils.isEmptyObject(obj) ? null : cloneDeep(obj);
    }
};

/**
 * Remove item in array by id
 * @param {*} id
 * @param {*} arr
 * @returns array
 */
export const removeItemInArrayById = (id, arr) => {
    let arrNew = arr.filter(item => item.id !== id);
    return arrNew;
};

/**
 * use to handle field when create ticket
 * @param {*} formData
 * @param {*} fieldListData
 * @returns
 */
export const getCustomFieldValueInFormData = async (formData, fieldListData, aiAutoSelectedData, sdautoSelectedData) => {
    let customFieldObj = {};
    let tagField = {};
    let htmlFields = [];
    let otherFieldsToS3 = [];

    for (const key in formData) {
        if (getPrefixOfId(key) === 'field') {
            const fieldData = fieldListData.filter(field => field.fieldId === key);
            if (!fieldData || Utils.isEmptyArray(fieldData)) continue;

            const structureUI = fieldData[0].structure.UI;
            switch (structureUI) {
                case Constant.FIELD_UI.TEXT_WITH_CHIP:
                case Constant.FIELD_UI.TAG:
                    if (
                        (fieldData[0].sysField ===
                            Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER &&
                            !isShowFieldEventTypeChatThread(aiAutoSelectedData)) ||
                        (fieldData[0].sysField ===
                            Constant.AI_AUTO.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS &&
                            !isShowFieldAIPDFPageSplitStatus(aiAutoSelectedData)) ||
                        (fieldData[0].sysField === Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT &&
                            !isShowReasoningEffortField(aiAutoSelectedData))
                    ) {
                        tagField[key] = [];
                    } else {
                        tagField[key] = formData[key];
                    }
                    break;
                case Constant.FIELD_UI.IFRAME:
                    customFieldObj[key] = formData[key]?.trim();
                    break;
                case Constant.FIELD_UI.URL:
                    let arrURL = [];
                    let stringArrURL = formData[key]?.trim();
                    let arrURLInput = stringArrURL.split(/\r?\n/);
                    if (!Utils.isEmptyArray(arrURLInput)) {
                        arrURLInput.forEach(url => {
                            url = url.trim();
                            if (url) {
                                arrURL.push(url);
                            }
                        });
                    }
                    customFieldObj[key] = arrURL;
                    break;
                case Constant.FIELD_UI.HTML:
                    const fieldId = key;
                    const htmlValue = formData[key] || '';
                    const tmpHtmlS3Key = `tmp/html/${fieldId}_random_id_${uuidv4()}.html`;

                    customFieldObj[key] = `public/${tmpHtmlS3Key}`; // save S3Key to db
                    
                    htmlFields.push({
                        path: tmpHtmlS3Key,
                        value: htmlValue
                    });
                    
                    break;
                case Constant.FIELD_UI.MARKDOWN: {
                    const markdownFieldId = key;
                    const markdownValue = formData[key] || '';
                    if (!markdownValue) {
                        customFieldObj[key] = '';
                        break;
                    }
                    // Validate size before upload to S3
                    const markdownSizeError = validateSizeOfS3TextField(markdownValue);
                    if (markdownSizeError) {
                        customFieldObj[key] = markdownValue; // keep raw text so validateExceedSizeOfFieldTicket can catch it and show error
                        break;
                    }
                    const tmpMarkdownS3Key = `tmp/markdown/${markdownFieldId}_random_id_${uuidv4()}.md`;
                    customFieldObj[key] = `public/${tmpMarkdownS3Key}`; // save S3Key to db
                    htmlFields.push({
                        path: tmpMarkdownS3Key,
                        value: markdownValue
                    });
                    break;
                }
                case Constant.FIELD_UI.JSON: {
                    const jsonFieldId = key;
                    const jsonValue = formData[key] || '';
                    // Skip S3 upload for empty/whitespace-only content, store null
                    if (!jsonValue || !jsonValue.trim()) {
                        customFieldObj[key] = null;
                        break;
                    }
                    // Validate size before upload to S3
                    const jsonSizeError = validateSizeOfS3TextField(jsonValue);
                    if (jsonSizeError) {
                        customFieldObj[key] = jsonValue; // keep raw text so validateExceedSizeOfFieldTicket can catch it and show error
                        break;
                    }
                    const tmpJsonS3Key = `tmp/json/${jsonFieldId}_random_id_${uuidv4()}.json`;
                    customFieldObj[key] = `public/${tmpJsonS3Key}`; // save S3Key to db
                    otherFieldsToS3.push({
                        path: tmpJsonS3Key,
                        value: jsonValue,
                        contentType: 'application/json'
                    });
                    break;
                }
                case Constant.FIELD_UI.TEXT_AREA:
                    {
                        
                        if ([Constant.SYS_FIELD.SDAUTO_SCRIPT].includes(fieldData[0]?.sysField)) {
                            const scriptValue = formData[key] || '';
                            const tmpScriptS3Key = `tmp/script/${key}_random_id_${uuidv4()}.js`;
                            customFieldObj[key] = `public/${tmpScriptS3Key}`; // save S3Key to db
                            htmlFields.push({
                                path: tmpScriptS3Key,
                                value: scriptValue
                            });
                            break;
                        }

                        if ([Constant.SYS_FIELD.SDAUTO_PARAMS_DESCRIPTION].includes(fieldData[0]?.sysField)) {
                            const dataValue = formData[key] || '';
                            const tmpScriptS3Key = `tmp/script/${key}_random_id_${uuidv4()}.json`;
                            customFieldObj[key] = `public/${tmpScriptS3Key}`; // save S3Key to db
                            otherFieldsToS3.push({
                                path: tmpScriptS3Key,
                                value: dataValue,
                                contentType: 'application/json'
                            });
                            break;
                        }

                        if (typeof formData[key] === 'string' && !Utils.isEmptyString(formData[key])) {
                            customFieldObj[key] = formData[key]?.trim();
                        } else {
                            customFieldObj[key] = formData[key];
                        }
                        break;
                    }
                default:
                    if (typeof formData[key] === 'string' && !Utils.isEmptyString(formData[key])) {
                        customFieldObj[key] = formData[key]?.trim();
                    } else {
                        customFieldObj[key] = formData[key];
                    }
                    break;
            }
        }
    }

    // handle upload file html to S3
    if (htmlFields.length > 0) {
        await Promise.all(htmlFields.map(field => {
            return uploadFileHtmlToS3(field.path, field.value)
        }));
    }

    if (!Utils.isEmptyArray(otherFieldsToS3)) {
        await Promise.all(otherFieldsToS3.map(field => {
            return uploadFileToS3WithContentType(field.path, field.value, field.contentType)
        }));
    }

    customFieldObj.tagField = tagField;
    return JSON.stringify(customFieldObj);
};

/**
 * use to handle field when edit ticket
 * @param {*} formData
 * @param {*} fields
 * @param {*} mapDataIdToId
 * @returns
 */
const getFieldsValueEdited = (formData, fields, mapDataIdToId) => {
    let editedFieldValue = {
        newFieldValue: []
    };

    for (const key in mapDataIdToId) {
        if (fields.hasOwnProperty(`${key}`) && mapDataIdToId.hasOwnProperty(`${key}`)) {
            editedFieldValue[`${mapDataIdToId[`${key}`]}`] = JSON.stringify({
                value: fields[`${key}`]
            });
        } else if (fields.hasOwnProperty(`${key}`) && !mapDataIdToId.hasOwnProperty(`${key}`)) {
            editedFieldValue.newFieldValue.push({ [key]: fields[`${key}`] });
        }
    }

    for (const key in formData) {
        if (!fields.hasOwnProperty(`${key}`)) {
            if (mapDataIdToId[`${key}`]) {
                editedFieldValue[`${mapDataIdToId[`${key}`]}`] = JSON.stringify({
                    value: formData[`${key}`]
                });
            } else {
                editedFieldValue?.newFieldValue.push({ [key]: formData[`${key}`] });
            }
        }
    }

    for (const key in fields) {
        if (
            !mapDataIdToId.hasOwnProperty(`${key}`) &&
            !editedFieldValue?.newFieldValue?.includes(key)
        ) {
            editedFieldValue.newFieldValue.push({ [key]: fields[`${key}`] });
        }
    }
    return editedFieldValue;
};

const putFieldDataToS3BeforeEditTicket = async (editedFieldObj, mapDataIdToId, fieldListDefault, ticketDetail) => {
    let handledData = { ...editedFieldObj };
    let htmlFields = [];
    let scriptFields = [];
    let jsonFields = [];

    for (const [ticketFieldId, fieldValue] of Object.entries(editedFieldObj)) {

        if (ticketFieldId === 'newFieldValue') {
            let newFieldArr = fieldValue.map(field => {
                const [fieldKey, fieldVal] = Object.entries(field)[0];

                let findInListDefault = fieldListDefault.find(f => f.id === fieldKey);
                if (!findInListDefault) return field;

                if (findInListDefault.structure?.UI === Constant.FIELD_UI.HTML) {
                    let pathS3 = buildHtmlFieldValueS3Key(ticketDetail.id, fieldKey, ticketDetail.affiliationOrganization);

                    htmlFields.push({
                        path: pathS3.replace(/^public\//, ""),
                        value: fieldVal
                    });

                    return { [fieldKey]: pathS3 };
                }
                
                if ([Constant.SYS_FIELD.SDAUTO_SCRIPT, Constant.SYS_FIELD.SDAUTO_PARAMS_DESCRIPTION].includes(findInListDefault?.sysField)) {
                    let pathScriptS3 = buildScriptFieldValueS3Key(ticketDetail.id, fieldKey, ticketDetail.affiliationOrganization);
                    let contentType = 'application/javascript';
                    if (findInListDefault?.sysField === Constant.SYS_FIELD.SDAUTO_PARAMS_DESCRIPTION) {
                        contentType = 'application/json';
                    }
                    scriptFields.push({
                        path: pathScriptS3.replace(/^public\//, ""),
                        value: fieldVal,
                        contentType: contentType
                    });
                    return { [fieldKey]: pathScriptS3 };
                }

                if (findInListDefault.structure?.UI === Constant.FIELD_UI.MARKDOWN) {
                    let pathS3 = buildMarkdownFieldValueS3Key(ticketDetail.id, fieldKey, ticketDetail.affiliationOrganization);

                    htmlFields.push({
                        path: pathS3.replace(/^public\//, ""),
                        value: fieldVal
                    });

                    return { [fieldKey]: pathS3 };
                }

                if (findInListDefault.structure?.UI === Constant.FIELD_UI.JSON) {
                    // Skip S3 upload for empty/whitespace-only content
                    if (!fieldVal || !fieldVal.trim()) {
                        return { [fieldKey]: null };
                    }
                    let pathS3 = buildJsonFieldValueS3Key(ticketDetail.id, fieldKey, ticketDetail.affiliationOrganization);

                    jsonFields.push({
                        path: pathS3.replace(/^public\//, ""),
                        value: fieldVal,
                        contentType: 'application/json'
                    });

                    return { [fieldKey]: pathS3 };
                }

                return field;
            });

            handledData['newFieldValue'] = newFieldArr;
            continue;
        }

        let cloneFieldValue = Utils.convertJSONDataToObject(fieldValue)?.value;
        let fieldId = Object.keys(mapDataIdToId).find(id => mapDataIdToId[id] === ticketFieldId);
        if (!fieldId) continue;

        let findInListDefault = fieldListDefault.find(field => field.id === fieldId);
        if (!findInListDefault) continue;

        if (findInListDefault.structure?.UI === Constant.FIELD_UI.HTML) {
            let pathS3 = buildHtmlFieldValueS3Key(ticketDetail.id, fieldId, ticketDetail.affiliationOrganization);


            handledData[ticketFieldId] = JSON.stringify({ value: pathS3 });
            htmlFields.push({
                path: pathS3.replace(/^public\//, ""), 
                value: cloneFieldValue
            });
        }
        
        if ([Constant.SYS_FIELD.SDAUTO_SCRIPT, Constant.SYS_FIELD.SDAUTO_PARAMS_DESCRIPTION].includes(findInListDefault?.sysField)) {
            let pathS3 = buildScriptFieldValueS3Key(ticketDetail.id, fieldId, ticketDetail.affiliationOrganization);
            let contentType = 'application/javascript';
            if (findInListDefault?.sysField === Constant.SYS_FIELD.SDAUTO_PARAMS_DESCRIPTION) {
                contentType = 'application/json';
            }
            handledData[ticketFieldId] = JSON.stringify({ value: pathS3 });
            scriptFields.push({
                path: pathS3.replace(/^public\//, ""), 
                value: cloneFieldValue,
                contentType: contentType
            });
        }

        if (findInListDefault.structure?.UI === Constant.FIELD_UI.MARKDOWN) {
            let pathS3 = buildMarkdownFieldValueS3Key(ticketDetail.id, fieldId, ticketDetail.affiliationOrganization);

            handledData[ticketFieldId] = JSON.stringify({ value: pathS3 });
            htmlFields.push({
                path: pathS3.replace(/^public\//, ""),
                value: cloneFieldValue
            });
        }

        if (findInListDefault.structure?.UI === Constant.FIELD_UI.JSON) {
            // Skip S3 upload for empty/whitespace-only content
            if (!cloneFieldValue || !cloneFieldValue.trim()) {
                handledData[ticketFieldId] = JSON.stringify({ value: null });
            } else {
                let pathS3 = buildJsonFieldValueS3Key(ticketDetail.id, fieldId, ticketDetail.affiliationOrganization);

                handledData[ticketFieldId] = JSON.stringify({ value: pathS3 });
                jsonFields.push({
                    path: pathS3.replace(/^public\//, ""),
                    value: cloneFieldValue,
                    contentType: 'application/json'
                });
            }
        }
    }

    const uploadTasks = [
        { fields: htmlFields, uploader: uploadFileHtmlToS3 },
        { fields: scriptFields, uploader: uploadFileScriptToS3 },
        { fields: jsonFields, uploader: uploadFileToS3WithContentType }
    ];
    
    for (const { fields, uploader } of uploadTasks) {
        if (fields.length === 0) continue;
        try {
            await Promise.all(fields.map(field => uploader(field.path, field.value, field.contentType || '')));
        } catch (error) {
            console.log('put S3 error: ', error)
        }
    }

    return handledData;
};


export const getEditTicketData = (formData, fieldListData, aiAutoSelectedData, sdautoSelectedData) => {
    const getTagValue = tagValueList => {
        let listSelectedItem = [];
        if (!isEmptyArray(tagValueList)) {
            for (const tagItem of tagValueList) {
                if (typeof tagItem === 'string') {
                    listSelectedItem.push(tagItem);
                    continue;
                }

                if (!Utils.isEmptyObject(tagItem)) {
                    listSelectedItem.push(tagItem.value);
                }
            }
        }
        return listSelectedItem;
    };
    let customFieldObj = {};
    let tagField = {};
    for (const key in formData) {
        if (getPrefixOfId(key) === 'field') {
            const fieldData = fieldListData.filter(field => field.fieldId === key);

            switch (fieldData[0]?.structure?.UI) {
                case Constant.FIELD_UI.TAG:
                case Constant.FIELD_UI.TEXT_WITH_CHIP:
                    if (
                        (fieldData[0].sysField ===
                            Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER &&
                            !isShowFieldEventTypeChatThread(aiAutoSelectedData)) ||
                        (fieldData[0].sysField ===
                            Constant.AI_AUTO.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS &&
                            !isShowFieldAIPDFPageSplitStatus(aiAutoSelectedData)) ||
                        (fieldData[0].sysField === Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT &&
                            !isShowReasoningEffortField(aiAutoSelectedData))
                    ) {
                        tagField[key] = [];
                        customFieldObj[key] = [];
                    } else {
                        customFieldObj[key] = getTagValue(formData[key]);
                        tagField[key] = formData[key];
                    }

                    break;
                case Constant.FIELD_UI.IFRAME:
                    customFieldObj[key] = formData[key]?.trim();
                    break;
                case Constant.FIELD_UI.URL:
                    let arrURL = [];
                    let stringArrURL = formData[key]?.trim();
                    let arrURLInput = stringArrURL.split(/\r?\n/);
                    if (!Utils.isEmptyArray(arrURLInput)) {
                        arrURLInput.forEach(url => {
                            url = url.trim();
                            if (url) {
                                arrURL.push(url);
                            }
                        });
                    }
                    customFieldObj[key] = arrURL;
                    break;
                default:
                    customFieldObj[key] = formData[key];
                    break;
            }
        }
    }
    customFieldObj.tagField = tagField;
    return customFieldObj;
};

export const validateURL = url => {
    let urlTrim = url.trim();
    // let formatRegex = Constant.URL_REGEX;
    const urlType = detectUrlType(urlTrim);
    let validateResult = false;
    switch (urlType) {
        case Constant.PROTOCOL.HTTP:
        case Constant.PROTOCOL.HTTPS:
        case Constant.PROTOCOL.FTP:
        case Constant.PROTOCOL.FILE:
        case Constant.PROTOCOL.NOTES:
            validateResult = true;
            break;
        default:
            break;
    }
    if (checkWhitespace(urlTrim)) {
        return false;
    }
    return validateResult;
};

const detectUrlType = (url) => {
    const formats = [
        { type: Constant.PROTOCOL.HTTP, regex: /^http:\/\// },
        { type: Constant.PROTOCOL.HTTPS, regex: /^https:\/\// },
        { type: Constant.PROTOCOL.FTP, regex: /^ftp:\/\// },
        { type: Constant.PROTOCOL.FILE, regex: /^file:\/\// },
        { type: Constant.PROTOCOL.NOTES, regex: /^(Notes|notes):\/\// },
    ];
    for (const format of formats) {
        if (format.regex.test(url)) {
            return format.type;
        }
    }
    return '';
}

export const checkWhitespace = (string) => {
    return /\s(?![^/]*$)/.test(string);
}

const isSystemField = keyId => {
    const listSystemField = systemField.filter(sysField => sysField.id === keyId);
    return listSystemField.length > 0;
};
export const isTypeObject = data => {
    if (isEmpty(data)) {
        return false;
    }
    return typeof data === 'object';
};

export const isTypeFunction = data => {
    return typeof data === 'function';
};

export const getPanelInfo = (panelId, panelList) => {
    if (!panelList || Utils.isEmptyArray(panelList)) return;
    return panelList.find(panel => panel.id === panelId);
};

export const encodeDataByCrypto = (data, key) => {
    data = typeof data === 'string' ? data : JSON.stringify(data);
    const encryptData = crypto.AES.encrypt(data, key).toString();
    let encodeURI = encodeURIComponent(encryptData);
    return encodeURI;
};

export const decodeDataByCrypto = (data, key) => {
    const encryptData = crypto.AES.decrypt(decodeURIComponent(data), key);
    let result = convertJSONDataToObject(encryptData.toString(crypto.enc.Utf8));
    return result;
};

export const isAnonymousQATicket = ticket => {
    if (!ticket || !ticket.hasOwnProperty('anonymousQaStatus') || !ticket.anonymousQaStatus) {
        return false;
    }

    return true;
};

export const isAnonymousQATicketFromLiveChat = ticket => {
    if (ticket?.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT) {
        return true;
    }
    return false;
};

export const isAnonymousLiveChatWaitingTicket = ticket => {
    if (ticket?.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT) {
        if (ticket?.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.CHAT_NOW) return false;
        return true;
    }
    return false;
};

export const isAnonymousQAWaitingTicket = ticket => {
    return (
        isAnonymousQATicket(ticket) &&
        ticket?.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.WAITING_APPROVE
    );
};

export const isAnonymousQAWaitingOrEndLiveChatTicket = ticket => {
    return (
        isAnonymousQATicketFromLiveChat(ticket) &&
        (ticket?.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.WAITING_APPROVE ||
            ticket?.anonymousQaStatus ===
                Constant.ANONYMOUS_TICKET_STATUS.END_LIVE_CHAT_AGENT_NOT_RESPONSE ||
            ticket?.anonymousQaStatus ===
                Constant.ANONYMOUS_TICKET_STATUS.END_LIVE_CHAT_CASE_TICKET_WAITING) && !ticket?.deletedAt
    );
};

export const isAnonymousQALiveChatDeleted = ticket => {
    return isAnonymousQATicketFromLiveChat(ticket) && ticket?.deletedAt;
};

export const isAnonymousQARejectTicket = ticket => {
    return (
        isAnonymousQATicket(ticket) &&
        ticket?.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.REJECTED
    );
};

export const isAnonymousQAApproveTicket = ticket => {
    return (
        isAnonymousQATicket(ticket) &&
        ticket?.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.APPROVE
    );
};

const isAnonymousQALiveChatTicket = ticket => {
    return ticket?.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.CHAT_NOW;
};

const isAnonymousQAEndLiveChatTicket = ticket => {
    return ticket?.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.END_LIVE_CHAT;
};

const isAnonymousQAExpireLiveChat = ticket => {
    return isAnonymousQATicket(ticket) && (ticket.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.END_LIVE_CHAT_AGENT_NOT_RESPONSE || ticket.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.END_LIVE_CHAT_CASE_TICKET_WAITING);
}


export const isDisableApproveRejectAnonymousQaTicket = (ticket) => {
    if (!isAnonymousQAWaitingTicket(ticket)) return true;
    return false;
};

export const isExpiredTimeLogin = expiredAtByMiliseconds => {
    const todayByMiliseconds = new Date(Date.now()).getTime();
    return todayByMiliseconds > expiredAtByMiliseconds ? true : false;
};

const isExpired = expireAt => {
    if (Utils.isEmpty(expireAt)) {
        return false;
    }
    const todayByMiliseconds = new Date(Date.now()).getTime();

    return todayByMiliseconds > expireAt ? true : false;
};

export const getUserStatus = user => {
    const expiredAtByMiliseconds = isNaN(user.expireAt)
        ? new Date(user.expireAt).getTime()
        : user.expireAt;
    try {
        if (user.active === Constant.ACTIVE_FLAG.REJECT) {
            return Constant.STATUS_OF_USER.REJECT;
        }

        if (user.active === Constant.ACTIVE_FLAG.DELETED) {
            return Constant.STATUS_OF_USER.DELETED;
        }

        if (user.active === Constant.ACTIVE_FLAG.NOT_INVITED) {
            return Constant.STATUS_OF_USER.NOT_INVITED;
        }

        if (user.active) {
            return Constant.STATUS_OF_USER.ACTIVE;
        } else if (isEmpty(user.expireAt)) {
            return Constant.STATUS_OF_USER.WAITING;
        } else if (!expiredAtByMiliseconds || isNaN(expiredAtByMiliseconds)) {
            return Constant.STATUS_OF_USER.WAITING;
        }
        return isExpiredTimeLogin(expiredAtByMiliseconds)
            ? Constant.STATUS_OF_USER.REJECT
            : Constant.STATUS_OF_USER.WAITING;
    } catch (err) {
        console.error({ expiredAt: err });
        return Constant.STATUS_OF_USER.WAITING;
    }
};

/**
 * getB2CStatusInProject
 * @param {*} user
 * @param {*} activeInProject
 * @returns status
 */
export const getB2CStatusInProject = (user, activeInProject) => {
    if (!user || isEmptyObject(user) || !activeInProject) return;
    let statusInProject;
    let statusInCorporation = getUserStatus(user);

    switch (true) {
        case statusInCorporation === Constant.STATUS_OF_USER.WAITING &&
            activeInProject === Constant.ACTIVE_FLAG.ACTIVE:
            statusInProject = Constant.STATUS_OF_USER.WAITING;
            break;
        case activeInProject === Constant.ACTIVE_FLAG.DELETED:
            statusInProject = Constant.STATUS_OF_USER.DELETED;
            break;
        case statusInCorporation === Constant.STATUS_OF_USER.REJECT:
            statusInProject = Constant.STATUS_OF_USER.REJECT;
            break;
        case statusInCorporation === Constant.STATUS_OF_USER.ACTIVE &&
            activeInProject === Constant.ACTIVE_FLAG.ACTIVE:
            statusInProject = Constant.STATUS_OF_USER.ACTIVE;
            break;
        case statusInCorporation === Constant.STATUS_OF_USER.DELETED:
            statusInProject = Constant.STATUS_OF_USER.DELETED;
            break;
        default:
            break;
    }

    return statusInProject;
};

export const getShortName = name => {
    if (isEmptyString(name)) {
        return '';
    }

    let firstName = name.substring(0, 1);
    let lastName = '';
    if (/[^a-z0-9\-\p{L}\p{N}\p{S}]/gu.test(firstName)) {
        firstName = name.substring(0, 2);
        lastName = name.substring(2, 3);
        if (/[^a-z0-9\-\p{L}\p{N}\p{S}]/gu.test(lastName)) {
            lastName = name.substring(2, 4);
        }
    } else {
        lastName = name.substring(1, 2);
        if (/[^a-z0-9\-\p{L}\p{N}\p{S}]/gu.test(lastName)) {
            lastName = name.substring(1, 3);
        }
    }
    let shortName = `${firstName}${lastName}`;
    return shortName;
};

export const formatStringUpperCaseFirstLetter = name => {
    if (isEmpty(name) || isEmptyString(name)) {
        return '';
    }
    return name[0].toUpperCase() + name.slice(1).toLowerCase();
};

export const getUpdatedTimeTicket = (isHelpDesk, ticket) => {
    const updatedObject = isHelpDesk
        ? Utils.convertJSONDataToObject(ticket.updatedForDesk)
        : Utils.convertJSONDataToObject(ticket.updatedForCustomer);
    const defaultResult = {
        updatorUserName: ticket.updatorUserName,
        updatedTime: getDateTimeByFormatYYYYMMDDHHMM(ticket.updatedAt)
    };

    if (isEmptyString(updatedObject) || isEmptyObject(updatedObject) || ticket.ticketType === Constant.TICKET_TYPE.TASK ) {
        return defaultResult;
    }

    const ticketEvent = updatedObject.ticketEvent;
    const chatEvent = updatedObject.chatEvent;
    let ticketUpdatedTime = ticketEvent?.updatedTime ? new Date(ticketEvent.updatedTime) : null;
    let chatUpdatedTime = chatEvent?.updatedTime ? new Date(chatEvent.updatedTime) : null;

    if (!ticketUpdatedTime || !chatUpdatedTime) {
        if (chatUpdatedTime) {
            chatEvent.updatedTime = getDateTimeByFormatYYYYMMDDHHMM(chatUpdatedTime);
            return chatEvent;
        }
        if (ticketUpdatedTime) {
            ticketEvent.updatedTime = getDateTimeByFormatYYYYMMDDHHMM(ticketUpdatedTime);
            return ticketEvent;
        }
        return defaultResult;
    }

    if (ticketUpdatedTime > chatUpdatedTime) {
        ticketEvent.updatedTime = getDateTimeByFormatYYYYMMDDHHMM(ticketUpdatedTime);
        return ticketEvent;
    }

    chatEvent.updatedTime = getDateTimeByFormatYYYYMMDDHHMM(chatUpdatedTime);
    if (ticket.ticketType === Constant.TICKET_TYPE.TASK) {
        chatEvent.updatedTime = getDateTimeByFormatYYYYMMDDHHMM(new Date(ticket.updatedAt));  
    }
    return chatEvent;
};

/**
 * Replaces URLs in a text string with anchor tags (<a>) with the target="_blank" attribute.
 * 
 * This function takes a text string as input and returns a new string with all URLs wrapped in anchor tags. 
 * When clicked, these links will open in a new tab or window.
 *
 * @param {string} text The text string to process.
 * @returns {string} The modified text string with replaced URLs.
 */

function truncateText(text, maxLength = 36) {
    // Kiểm tra nếu độ dài của chuỗi lớn hơn maxLength
    if (text.length > maxLength) {
        // Cắt chuỗi và thêm "..." vào cuối
        return text.slice(0, maxLength);
    }
    // Trả về chuỗi ban đầu nếu không cần cắt ngắn
    return text;
}

const removeExtraCharactersOfIdTicket = (id) => {
    let parts = id.split('_');
    let prefix = parts[0];
    let suffix = parts.slice(1).join('_');

    const newSuffix = truncateText(suffix,36);

    return `${prefix}_${newSuffix}`

}

/**
 * using for hotfix to replace when using markdown for display data AIChat
 * @param {*} str 
 * @returns 
 */
function hasMatchingPairs(str) {
    // symmetrical chars 
    const pairs = {
        ')': '(',
        ']': '[',
        '}': '{',
        '"': '"',
        "'": "'",
        '’': "‘",
        '`': '`'
    };

    // get last chart
    const lastChar = str.slice(-1);

    // checking last chart in pairs or not
    if (!Object.keys(pairs).includes(lastChar)) {
        return false;
    }

     //Check if the preceding character is the same character as the last character
     if (str.slice(-2, -1) === lastChar) {
        return false;
    }

    // Get the opposite sign corresponding to the last character
    const matchingChar = pairs[lastChar];

    // Check for the existence of a backspace in the string before the last character
    return str.slice(0, -1).includes(matchingChar);
}

export const replaceUrls = (text = '', isFromQA = false, isPublicSite = false, className = '', isSendFromMe = false, isAIChat = false) => {
    if (!text) return '';

    const urlRegex = /(http|https|ftp|file|Notes|notes):\/\/[^\s)\]\}"'`<>^&({\[]+[^\s)\]\}"'`<>^&({\[,\.!?*@%$#\\/]/g; // Regex để nhận diện các URL có thể liền kề với văn bản

    const regexTitleIsUrl = /\[(.*?)\]/g; // title is url into []
    let matches;
    let urlsNeedReplace = [];
    
    
    while ((matches = regexTitleIsUrl.exec(text)) !== null) {
        if (matches[1].match(urlRegex))
            urlsNeedReplace.push({
                text: matches[1], // get content into []
                start: matches.index +1, // started position of replace string
                end: regexTitleIsUrl.lastIndex -1 // ended position of replace string
            });
    }

    if (!isEmptyArray(urlsNeedReplace)) {
        for (const [idx, urlNeedReplace] of urlsNeedReplace.entries()) {
            let started = urlNeedReplace?.start;
            let ended = urlNeedReplace?.end;
            if (idx > 0) {
                started = urlNeedReplace?.start + 2 * idx;
                ended = urlNeedReplace?.end + 2 * idx;
            }
            text = text?.slice(0, started) + ` ${urlNeedReplace?.text} ` + text?.slice(ended);
        }
    }

    // Sử dụng hàm replace với regex để thay thế các URL
    const replacedText = text.replace(urlRegex, (url) => {
        const urlType = detectUrlType(url);
        let whiteSpace = ""
        let whiteSpaceAndParenthesis = ""
        let urlDisplay = url
        let urlRedirect = url

        if (!isSendFromMe && isAIChat) {
            whiteSpace = `&nbsp;`;
            let replaceChar = ""
            let urlForDisplay = url;
            let urlForRedirect = url;
            urlForDisplay = urlForDisplay.replaceAll('&nbsp;,',' ')
            urlForDisplay = urlForDisplay.replaceAll(')&quot;',' )"')
            urlForDisplay = urlForDisplay.replaceAll('&quot;,',' "')
            urlForDisplay = urlForDisplay.replaceAll('&#39;,',' \'')
            urlForDisplay = urlForDisplay.replaceAll('&nbsp;',' ')
            urlForDisplay = urlForDisplay.replaceAll('&quot;',' "')
            urlForDisplay = urlForDisplay.replaceAll('&#39;',' \'')
            if (!hasMatchingPairs(urlForDisplay))
                urlDisplay = urlForDisplay.replace(/([)\]"\}\\’'`])$/g, match => {
                    replaceChar = match;
                    return '';
                });

            urlForRedirect = urlForRedirect.replaceAll('&nbsp;,','')
            urlForRedirect = urlForRedirect.replaceAll('&quot;,','"')
            urlForRedirect = urlForRedirect.replaceAll('&#39;,','\'')
            urlForRedirect = urlForRedirect.replaceAll('&nbsp;','')
            urlForRedirect = urlForRedirect.replaceAll('&quot;','"')
            urlForRedirect = urlForRedirect.replaceAll('&#39;','\'')
            if (!hasMatchingPairs(urlForRedirect))
                urlRedirect = urlForRedirect.replace(/([)\]"\}\\’'`])$/g, '').replace(/[\]"\}\\’'`]$/g, '');
            whiteSpaceAndParenthesis = `&nbsp;${replaceChar}`;
        }

        switch (urlType) {
            case Constant.PROTOCOL.HTTP:
            case Constant.PROTOCOL.HTTPS:
                
                let fullUrl;
                try {
                    fullUrl = new URL(url);
                } catch (_) {
                    fullUrl = ''
                }  

                if (fullUrl) {
                    let urlPathName = fullUrl.pathname;
                    let matchUrl = matchPath(urlPathName, {
                        path: Constant.SHARE_TICKET_ROUTER,
                        exact: true,
                        strict: true
                    });
                    const matchUrlShortLink = matchPath(urlPathName, {
                        path: Constant.SHORT_LINK_TICKET_ROUTER,
                        exact: true,
                        strict: true
                    });

                    // So sánh domain và router
                    if (
                        ((!Utils.isEmptyObject(matchUrl) && matchUrl.isExact) ||
                            !!matchUrlShortLink?.isExact) &&
                        !isPublicSite
                    ) {
                        const params = matchUrl ? matchUrl.params : null;
                        let targetUrl = url;
                        if (params?.id) {
                            const id = params.id;
                            const newId = removeExtraCharactersOfIdTicket(id);
                            targetUrl = url.replace(id, newId);
                        }
                        return isFromQA
                            ? `${whiteSpace}<span class='shared-ticket-link' style="text-decoration: underline" onClick="window.onClickUrlViewTicketFromQAChatThread('${targetUrl}')">${urlDisplay}</span>${whiteSpaceAndParenthesis}`
                            : `${whiteSpace}<span class='shared-ticket-link' style="text-decoration: underline" onClick="window.onClickUrlViewTicket('${targetUrl}')">${urlDisplay}</span>${whiteSpaceAndParenthesis}`;
                    } else {
                        return `${whiteSpace}<a href="${urlRedirect}" target="_blank" style="text-decoration: underline" class="${className}">${urlDisplay}</a>${whiteSpaceAndParenthesis}`;
                    }
                }
                
            case Constant.PROTOCOL.FTP:
            case Constant.PROTOCOL.FILE:
            case Constant.PROTOCOL.NOTES:
                return `${whiteSpace}<a href="${urlRedirect}" target="_blank" style="text-decoration: underline" class="${className}">${urlDisplay}</a>${whiteSpaceAndParenthesis}`;
            default:
                return `${whiteSpace}${urlDisplay}${whiteSpaceAndParenthesis}`; // Trường hợp mặc định, trả về chính URL ban đầu
        }
    });

    return replacedText;
};

const isNotChangedName = (language, nameForeign, nameTyping) => {
    if (
        isEmpty(nameForeign) ||
        isEmpty(nameTyping) ||
        isEmptyString(nameForeign) ||
        isEmptyString(nameTyping)
    ) {
        return true;
    }
    let newNameForeign = isEmpty(getTextByLanguage(language, nameForeign))
        ? nameForeign
        : getTextByLanguage(language, nameForeign);
    let newNameTyping = isEmpty(getTextByLanguage(language, nameTyping))
        ? nameTyping
        : getTextByLanguage(language, nameTyping);
    return newNameForeign === newNameTyping;
};

const setUpdatedTicketObject = (updateObject, currentUser) => {
    const currentTime = new Date().toISOString();
    let convertObject = Utils.convertJSONDataToObject(updateObject);
    convertObject.ticketEvent = {
        updatedTime: currentTime,
        updatedId: currentUser
    };

    if (!Utils.isEmptyObject(convertObject.ticketEvent)) {
        delete convertObject.ticketEvent.updatorUserName;
    }
    if (!Utils.isEmptyObject(convertObject.chatEvent)) {
        delete convertObject.chatEvent.updatorUserName;
    }

    return JSON.stringify(convertObject);
};

let charsets = {
    latin: { halfRE: /[!-~]/g, fullRE: /[！-～]/g, delta: 0xfee0 },
    hangul1: { halfRE: /[ﾡ-ﾾ]/g, fullRE: /[ᆨ-ᇂ]/g, delta: -0xedf9 },
    hangul2: { halfRE: /[ￂ-ￜ]/g, fullRE: /[ᅡ-ᅵ]/g, delta: -0xee61 },
    kana: {
        delta: 0,
        half: '｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ',
        full:
            '。「」、・ヲァィゥェォャュョッーアイウエオカキクケコサシ' +
            'スセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン゛゜'
    },
    extras: { delta: 0, half: '¢£¬¯¦¥₩\u0020|←↑→↓■°', full: '￠￡￢￣￤￥￦\u3000￨￩￪￫￬￭￮' }
};

let toFull = set => c =>
    set.delta
        ? String.fromCharCode(c.charCodeAt(0) + set.delta)
        : [...set.full][[...set.half].indexOf(c)];
let toHalf = set => c =>
    set.delta
        ? String.fromCharCode(c.charCodeAt(0) - set.delta)
        : [...set.half][[...set.full].indexOf(c)];
let re = (set, way) => set[way + 'RE'] || new RegExp('[' + set[way] + ']', 'g');

let sets = Object.keys(charsets).map(i => charsets[i]);
const toFullWidth = str0 =>
    sets.reduce((str, set) => str.replace(re(set, 'half'), toFull(set)), str0);

const toHalfWidth = str0 =>
    sets.reduce((str, set) => str.replace(re(set, 'full'), toHalf(set)), str0);

// Normarlize JP to fullWidth and alphaNumberic to halfWidth
const normarlizeSearchKeyword = str => {
    if (!str) return null;
    if (str.length === 0) return '';
    return toFullWidth(str) // all to full width
        .replace(
            // only alphanumberic to halfwidth
            /[\uff01-\uff5e]/g,
            function(ch) {
                return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
            }
        );
};

export const sortListBookmarkByNameASC = list => {
    if (Utils.isEmptyArray(list)) {
        return [];
    }
    return list.sort((a, b) => {
        let nameA = a.name;
        let nameB = b.name;
        return nameA.localeCompare(nameB);
    });
};

export const sortListByNameDictionaryASC = list => {
    if (Utils.isEmptyArray(list)) {
        return [];
    }
    return list.sort((a, b) => {
        let nameA = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, a.name);
        let nameB = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, b.name);
        return nameA.localeCompare(nameB);
    });
};

export const sortListByCorporationNameDictionartDESC = list => {
    if (Utils.isEmptyArray(list)) {
        return [];
    }
    return list.sort((a, b) => {
        let nameA = a.corporationName;
        let nameB = b.corporationName;
        return nameB.localeCompare(nameA);
    });
};

export const convertByteToGigaByte = (byte, numberDecimal) => {
    if (Utils.isEmptyString(byte)) return;
    if (
        Utils.isEmptyString(numberDecimal) ||
        !Number.isInteger(numberDecimal) ||
        (Number.isInteger(numberDecimal) && numberDecimal < 0)
    ) {
        return parseFloat(byte / (1024 * 1024 * 1024));
    }
    return parseFloat((byte / (1024 * 1024 * 1024)).toFixed(numberDecimal));
};

export const sortListByLabelDictionaryASC = (list, sortField = '') => {
    if (Utils.isEmptyArray(list)) {
        return [];
    }
    if (!sortField) {
        sortField = 'label';
    }
    return list.sort((a, b) => {
        let nameA = a[sortField];
        let nameB = b[sortField];
        return nameA.localeCompare(nameB);
    });
};

export const sortListByNameCorpDictionaryASC = list => {
    if (Utils.isEmptyArray(list)) {
        return [];
    }
    return list.sort((a, b) => {
        let nameA = a?.title;
        let nameB = b?.title;
        return nameA.localeCompare(nameB);
    });
};

export const sortListByTitle = list => {
    if (Utils.isEmptyArray(list)) {
        return [];
    }
    let listClone = cloneDeep(list)
    return listClone.sort((a, b) => {
        let nameA = a?.title;
        let nameB = b?.title;
        return nameA.localeCompare(nameB);
    });
};

export const escapeHtmlCharacters = htmlStr => {
    return htmlStr
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

export const giveBackHtmlCharacters = htmlStr => {
    return htmlStr
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
};

const isProjectDeskOn = project => {
    try {
        return !!project?.isDesk;
    } catch (error) {
        console.debug('isProjectDeskOn error', error);
        return false;
    }
};

/**
 * Check if a value represents an "enabled" service permission.
 * Handles string ON, boolean true, and string '1'.
 */
const isEnabledServiceValue = value =>
    value === Constant.STATUS_SERVICE_PERMISSION.ON || value === true || value === '1';

export const isPublicDesk = project => {
    if (isEmptyObject(project)) return;

    return (
        project.type === Constant.PROJECT_TYPE.GENERAL &&
        project.isPublic &&
        project.isDesk &&
        !project.isGuest
    );
};

export const isPrivateDesk = project => {
    if (isEmptyObject(project)) return;

    return (
        project.type === Constant.PROJECT_TYPE.GENERAL &&
        !project.isPublic &&
        project.isDesk &&
        !project.isGuest
    );
};

export const isPublicOffDeskOff = project => {
    if (isEmptyObject(project)) return;

    return (
        project.type === Constant.PROJECT_TYPE.GENERAL &&
        !project.isPublic &&
        !project.isDesk &&
        !project.isGuest
    );
};

export const isProjectGuest = project => {
    if (isEmptyObject(project)) return;

    return (
        project.type === Constant.PROJECT_TYPE.GENERAL &&
        !project.isPublic &&
        !project.isDesk &&
        project.isGuest
    );
};

export const isProjectGuestDesk = project => {
    if (isEmptyObject(project)) return;

    return (
        project.type === Constant.PROJECT_TYPE.GENERAL &&
        !project.isPublic &&
        project.isDesk &&
        project.isGuest
    );
};

export const isGuestUser = userDetail => {
    if (isEmptyObject(userDetail) || isEmpty(userDetail)) {
        return false;
    }
    if (userDetail.type === Constant.USER_TYPE.GENERAL && userDetail.isGuest) {
        return true;
    }
    return false;
};

export const isGuestContractType = org => {
    if (!Utils.isEmptyObject(org)) {
        if (
            org.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST ||
            org.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
        ) return true;
        return false;
    }
    return false;
}

export const isGeneralUserWithoutGuest = userDetail => {
    if (isEmptyObject(userDetail) || isEmpty(userDetail)) {
        return false;
    }
    if (userDetail.type === Constant.USER_TYPE.GENERAL && !userDetail.isGuest) {
        return true;
    }
    return false;
};

export const isGeneralUser = userDetail => {
    if (isEmptyObject(userDetail) || isEmpty(userDetail)) {
        return false;
    }
    if (userDetail.type === Constant.USER_TYPE.GENERAL) {
        return true;
    }
    return false;
};

export const isInternalUser = userDetail => {
    if (isEmptyObject(userDetail) || isEmpty(userDetail)) {
        return false;
    }
    if (userDetail.type === Constant.USER_TYPE.INTERNAL) {
        return true;
    }
    return false;
};

export const isB2CUser = userDetail => {
    if (isEmptyObject(userDetail) || isEmpty(userDetail)) {
        return false;
    }
    if (userDetail.type === Constant.USER_TYPE.CUSTOMER) {
        return true;
    }
    return false;
};

export const getPanelData = (panelId, panelList) => {
    if (!panelId || !panelList || isEmptyArray(panelList)) return;
    return panelList.find(panel => panel.id === panelId);
};

const filterDuplicateItemsOfArray = (array, checkDuplicateFunction) => {
    let listItemUnique = [];
    array?.forEach(item => {
        if (!checkDuplicateFunction(listItemUnique, item)) {
            listItemUnique.push(item);
        }
    });
    return listItemUnique;
};

const checkArrayIncludesItem = (array, item) => {
    return array?.includes(item);
};

/**
 * removeDuplicateInArrayById
 * @param {*} array
 * @returns
 */
const removeDuplicateInArrayById = array => {
    if (isEmptyArray(array)) return [];

    let newArray = array.filter(
        (value, index, self) => index === self.findIndex(t => t.id === value.id)
    );

    return newArray;
};

const upperCaseFirstLetter = string => `${string.slice(0, 1).toUpperCase()}${string.slice(1)}`;

const lowerCaseAllWordsExceptFirstLetters = string =>
    string.replaceAll(/\S*/g, word => `${word.slice(0, 1)}${word.slice(1).toLowerCase()}`);
const compareTwoArraySorted = (array1, array2) => {
    return array1.join('') === array2.join('');
};

/**
 * getUserNameWithActiveStatus
 * @param {*} userDetail
 * @returns
 */
const getUserNameWithActiveStatus = (userDetail, returnMailIfEmpty = false) => {
    if (isEmptyObject(userDetail)) return '';

    if (isB2CUser(userDetail)) {
        return getUserNameInDrilldown(userDetail);
    }

    let userName = getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail);
    if (userName) {
        userName = userName.trim();
    }
    if (isEmptyString(userName) && returnMailIfEmpty && userDetail.mail) {
        userName = Utils.getDisplayUserEmailWithoutSuffix(userDetail.mail);
    }
    if (userDetail.hasOwnProperty('active') && userDetail.active === Constant.ACTIVE_FLAG.DELETED) {
        userName = `${userName} (${Constant.SUFFIX_TEXT.DELETED_USER})`;
    }

    return userName;
};


/**
 * getUserNameInDrilldown
 * @param {Object} userDetail - User detail
 * @returns {string} User name in drilldown
 */
const getUserNameInDrilldown = (userDetail) => {
    if (isEmptyObject(userDetail)) return '';

    let userName = getUserNameFromUserDetail(userDetail);
    if (userName) {
        userName = userName.trim();
    }
    if (isEmptyString(userName) && userDetail.mail) {
        userName = Utils.getDisplayUserEmailWithoutSuffix(userDetail.mail);
    }
    if (userDetail.hasOwnProperty('active') && userDetail.active === Constant.ACTIVE_FLAG.DELETED) {
        userName = `${userName} (${Constant.SUFFIX_TEXT.DELETED_USER})`;
    }

    return userName;
};


/**
 * getUserNameFromUserDetail
 * 
 * @param {Object} userDetail - User detail
 * @param {string} userDetail.lastName - User's last name
 * @param {string} userDetail.firstName - User's given/first name
 * @param {string} userDetail.organizationName - User's organization name
 * @param {string} userDetail.tel - User's phone number
 * @returns {string} User name in drilldown
 */
const getUserNameFromUserDetail = (userDetail, languageType = Constant.LANGUAGE_TYPE.JP) => {
    try {
        if (isEmptyObject(userDetail)) return '';

        if (!userDetail || isEmptyObject(userDetail)) {
            return '';
        }

        const lastName = getTextByLanguage(languageType, userDetail.lastName);
        const firstName = getTextByLanguage(languageType, userDetail.firstName);
        const organizationName = userDetail.organizationName || '';
        const telephoneNumber = userDetail.tel ? `+${userDetail.tel}` : '';

        let nameParts = [lastName, firstName, organizationName, telephoneNumber];

        nameParts = nameParts.filter(name => name && !isEmptyString(name));
        return nameParts.join(' ').trim() || '';
    } catch (error) {
        console.error('❌ getUserNameFromUserDetail error:', error);
        return '';
    }
};

/**
 * getCorporationNameSuffixText
 * @param {*} corporationDetail
 * @returns
 */
const getCorporationNameSuffixText = corporationDetail => {
    let suffixText = '';
    if (!corporationDetail || isEmptyObject(corporationDetail)) {
        return suffixText;
    }

    if (corporationDetail.active === Constant.CORPORATION_ACTIVE.BLOCK) {
        suffixText = Constant.SUFFIX_TEXT.BLOCK_CORPORATION;
    }
    if (corporationDetail.active === Constant.CORPORATION_ACTIVE.DELETED) {
        suffixText = Constant.SUFFIX_TEXT.DELETED_CORPORATION;
    }

    return suffixText;
};

const getFileExtension = filename => {
    return filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
};

const updateNewDisplayNameOfProject = (project, newName) => {
    if (isEmptyObject(project) || isEmptyString(newName)) {
        return project;
    }
    let projectUpdate = { ...project };

    let newNameUpdate = {
        jp: {
            A: 'F',
            text: newName
        }
    };
    projectUpdate.name = JSON.stringify(newNameUpdate);

    return projectUpdate;
};

// using fetch api to control error
const handleRequest = promise => {
    return promise.then(response => [undefined, response]).catch(err => [err, undefined]);
};
const getTitle = settingTitle => {
    if (!settingTitle) return '';
    return settingTitle
        .filter(element => !element.isBreak)
        .map(element => element.text)
        .join(' ');
};

const getDateTimeByFormatHHMM = dateTimeString => {
    let dateTime = new Date(dateTimeString);
    let hours = dateTime.getHours() < 10 ? `0${dateTime.getHours()}` : dateTime.getHours();
    let minutes = dateTime.getMinutes() < 10 ? `0${dateTime.getMinutes()}` : dateTime.getMinutes();

    return `${hours}:${minutes}`;
};

const sortListTagFieldOfCategory = listTagField => {
    return listTagField.sort((a, b) => {
        if (a.priority && !b.priority) return -1;
        if (!a.priority && b.priority) return 1;
        return a.order - b.order;
    });
};

const sortCategoriesByOrder = listCategories => {
    return listCategories.sort((categoryA, categoryB) => {
        return categoryA.order - categoryB.order;
    });
};

const generateChatBotScript = projectId => {
    if (!projectId) return;
    return `<script id="sdesk-chatbot" src="${process.env.REACT_APP_CLOUD_FRONT_URL}/assets/chatbot.js?projectId=${projectId}" type="text/javascript"></script>`;
};

const isAnonymousQAWaitingTicketFromLiveChat = ticket => {
    if (
        ticket.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT &&
        ticket.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.WAITING_APPROVE
    ) {
        return true;
    }
    return false;
};

const initKeyFileSaveLogCreateTicketByUploadCsv = (
    corporationId,
    projectId,
    userId,
    uploadKey,
    hasPrefix = false,
    logObject = null,
    objectId = ''
) => {
    if (!corporationId || !projectId || !userId || !uploadKey) return;
    let keyFile = `${corporationId}/uploadCsvLog/${projectId}/${userId}/${uploadKey}.log`;
    if (logObject === 'tagitem') {
        keyFile = `${corporationId}/uploadCsvTagItem/${projectId}/${userId}/${uploadKey}.log`;
        if (objectId) {
            keyFile = `${corporationId}/uploadCsvTagItem/${projectId}/${userId}/${objectId}/${uploadKey}.log`;
        }
    }
    if (hasPrefix) {
        keyFile = `public/${keyFile}`;
    }
    return keyFile;
};

const renderUploadKeys = fileName => {
    if (!fileName) return;

    let timeStamp = Date.now().toString();
    return `${fileName}_${timeStamp}`;
};

const getPaginatedItems = (items, page, pageSize) => {
    var pg = page || 1,
        pgSize = pageSize || Constant.DEFAULT_PAGE_SIZE,
        offset = (pg - 1) * pgSize,
        pagedItems = drop(items, offset).slice(0, pgSize);
    return {
        page: pg,
        pageSize: pgSize,
        total: items.length,
        total_pages: Math.ceil(items.length / pgSize),
        data: pagedItems
    };
};

// Returns the raw status KEY + class. statusText is translated at render time
// (ListLog) via renderLogStatusText() so it re-translates when the dictionary loads lazily.
const mappingLogStatusText = (status, isNg = false, logObject = '') => {
    let statusTextKey,
        statusClass = '';
    switch (status) {
        case UserLogConstant.LOG_STATUS.INPROGRESS:
            statusTextKey = 'KNOWCRLB033';
            statusClass = 'warning';
            break;
        case UserLogConstant.LOG_STATUS.OK:
            statusTextKey = 'KNOWCRLB030';
            statusClass = 'success';
            if (isNg) {
                statusTextKey = logObject ? 'KNOWCRLB032' : 'KNOWCRLB031';
                statusClass = logObject ? 'danger' : 'warning';
            }
            break;
        case UserLogConstant.LOG_STATUS.NG:
            statusTextKey = 'KNOWCRLB031';
            statusClass = 'warning';
            break;
        case UserLogConstant.LOG_STATUS.ERROR:
            statusTextKey = 'KNOWCRLB032';
            statusClass = 'danger';
            break;
        default:
            break;
    }

    return { statusTextKey, statusClass };
};

// Translates statusText at RENDER time from the raw key returned by mappingLogStatusText.
const renderLogStatusText = statusTextKey => {
    if (!statusTextKey) return '';
    return trI18n(statusTextKey);
};

// Returns a RAW message descriptor (untranslated). line/totalLine stay numeric and are
// concatenated at render time (avoids dictionary bloat). Translation happens in renderLogMessage().
const mappingLogMessageByStatus = (status, line, totalLine, messageError, isNg = false, deleteMode = {}) => {
    let mappingStatus = status;
    if (!Utils.isEmptyObject(deleteMode)) {
        mappingStatus = deleteMode.isSuccess
            ? UserLogConstant.LOG_STATUS.MODE_DELETE_OK
            : UserLogConstant.LOG_STATUS.MODE_DELETE_ERROR;
    }

    return { mappingStatus, line, totalLine, messageError, isNg };
};

// Translates + concatenates the message at RENDER time from the raw descriptor returned by mappingLogMessageByStatus.
const renderLogMessage = messageData => {
    if (!messageData) return '';
    const { mappingStatus, line, totalLine, messageError, isNg } = messageData;
    switch (mappingStatus) {
        case UserLogConstant.LOG_STATUS.INPROGRESS:
            return `${line}/${totalLine}${trI18n('KNOWCRMSG012')}`;
        case UserLogConstant.LOG_STATUS.OK: {
            const description = isNg ? trI18n('KNOWCRMSG010') : trI18n('KNOWCRMSG009');
            return `${line}/${totalLine}${description}`;
        }
        case UserLogConstant.LOG_STATUS.ERROR: {
            const msg = !Utils.isEmptyString(messageError)
                ? `${tr('行目は')}${trI18n(`${messageError}`)}${trI18n('KNOWCRMSG011')}`
                : trI18n('NON_ERROR_CODE_MSG_LOG');
            return `${line}/${totalLine}${msg}`;
        }
        case UserLogConstant.LOG_STATUS.MODE_DELETE_OK:
            return trI18n('MSG-KNOW-LOG-DELETE-KNOWLEDGE-TICKET-SUCCEEDED')
                .replace('{{processed_line}}', line)
                .replace('{{all_line}}', totalLine);
        case UserLogConstant.LOG_STATUS.MODE_DELETE_ERROR:
            return trI18n('MSG-KNOW-LOG-DELETE-KNOWLEDGE-TICKET-FAILED')
                .replace('{{processed_line}}', line)
                .replace('{{all_line}}', totalLine);
        default:
            return '';
    }
};

// Returns a RAW array of { fieldName, msg } (untranslated). Translated at render via
// renderLogListItem() so the field name (FIELD_LABEL, possibly lazy) re-translates correctly.
const mappingLogErrorList = errorList => {
    if (!errorList?.length) return [];
    errorList = errorList?.filter(error => error?.msg !== 'MSG-KNOW-LOG-AUTO-CREATE-TAG-ITEM-SUCCEEDED')
    return errorList.map(error => ({ fieldName: error?.fieldName || '', msg: error?.msg || '' }));
};

const mappingLogSuccessList = errorList => {
    if (!errorList?.length) return [];
    errorList = errorList?.filter(error => error?.msg === 'MSG-KNOW-LOG-AUTO-CREATE-TAG-ITEM-SUCCEEDED')
    return errorList.map(error => ({ fieldName: error?.fieldName || '', msg: error?.msg || '' }));
};

// Translates + concatenates one warning item at RENDER: field name (trLabel) + message key (trI18n).
// Backward compatible: if a pre-joined string is passed, return it as-is.
const renderLogListItem = item => {
    if (!item) return '';
    if (typeof item === 'string') return item;
    const fieldNamePart = item.fieldName ? trLabel(item.fieldName) : '';
    // Success auto-create tag message ("{field}の選択項目を追加しました。") is a sentence that
    // starts with the particle "の", so the field name must be concatenated directly with no
    // " : " separator (unlike error items, which intentionally keep the separator).
    if (item.msg === 'MSG-KNOW-LOG-AUTO-CREATE-TAG-ITEM-SUCCEEDED') {
        return `${fieldNamePart}${trI18n(`${item.msg}`)}`;
    }
    const separator = item.fieldName ? ' : ' : '';
    return `${fieldNamePart}${separator}${trI18n(`${item.msg}`)}`;
};

/**
 * 
 * @param {string} corporationId 
 * @param {string} projectId 
 * @param {number} version 
 * @param {Constant.KEY_FILE_CSS_TYPE} type Constant.KEY_FILE_CSS_TYPE.PUBLIC_KNOWLEDGE_SITE: pks, Constant.KEY_FILE_CSS_TYPE.KNOWLEDGE_ROBO: robo.  it used to pks ago. So it's 0 default. 
 * @returns 
 */
const genKeyFileCss = (corporationId, projectId, version, type = Constant.KEY_FILE_CSS_TYPE.PUBLIC_KNOWLEDGE_SITE) => {
    if (!corporationId || !projectId || !version) return;
    let keyFile = '';
    switch (type) {
        case Constant.KEY_FILE_CSS_TYPE.KNOWLEDGE_ROBO:
            keyFile = `assets/${corporationId}/${projectId}/style/knowledge-robo-v${version}.css`;
            break;
        case Constant.KEY_FILE_CSS_TYPE.PUBLIC_KNOWLEDGE_SITE:
        default:
            keyFile = `assets/${corporationId}/${projectId}/style/public-knowledge-v${version}.css`;
            break;
    }
    return keyFile;
};

const genKLRoboMsgConfigS3path = (corporationId, projectId) => {
    if (!corporationId || !projectId) return '';
    return `${corporationId}/${projectId}/chat_bot/kl-robo-msg-config.json`;
}

const randomSubDomainCorporation = () =>{
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 8; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

const getUrlLinkCorporation = (contractType, subDomain) => {
    // LAST_CORP_DOMAIN
    let corporationDomain = localStorageUtil.getCorporationDomain()
        ? localStorageUtil.getCorporationDomain()
        : localStorageUtil.getLastLoginCorpDomain();

    let urlAfterLogout = `/login/${corporationDomain}`;
    
    if(!contractType || !subDomain) {
        return urlAfterLogout;
    }

    switch (contractType) {
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST:
            urlAfterLogout = `/login/${subDomain}/c/${corporationDomain}`
            break;
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK:
            urlAfterLogout = `/login/${subDomain}/p/${corporationDomain}`
            break;
        default:
            urlAfterLogout = `/login/${corporationDomain}`;
            break;
    }

    return urlAfterLogout;
}

const getUrlLinkCorporationSignedIn = (contractType, subDomain) => {
    let urlAfterSignedIn = `/${localStorageUtil.getCorporationDomain()}`;
    
    if(!contractType || !subDomain) {
        return urlAfterSignedIn;
    }

    switch (contractType) {
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST:
            urlAfterSignedIn = `/${subDomain}/c/${localStorageUtil.getCorporationDomain()}`
            break;
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK:
            urlAfterSignedIn = `/${subDomain}/p/${localStorageUtil.getCorporationDomain()}`
            break;
        default:
            urlAfterSignedIn = `/${localStorageUtil.getCorporationDomain()}`;
            break;
    }

    return urlAfterSignedIn;
}

const getUrlLinkShareLinkTicket = (subDomain, projectId, ticketId) => {
    if (!subDomain || !projectId || !ticketId) return '';
    return `share/${subDomain}/${projectId}/ticket/${ticketId}`;
};

const getUrlShortShareLinkTicket = ({ type, shortKey, subDomain, chatPostId }) => {
    if (!subDomain || !shortKey || !type) return '';
    return `share/${subDomain}/${type}/${shortKey}${!!chatPostId ? `?with_message=${chatPostId}` : ''}`;
};

const getUrlLinkShareLinkChatPost = (subDomain, projectId, ticketId, chatPostId) => {
    if (!subDomain || !projectId || !ticketId || !chatPostId) return '';
    return `share/${subDomain}/${projectId}/ticket/${ticketId}?with_message=${chatPostId}`;
};

const getTicketIdFromSharedLink = url => {
    const regex = /\/ticket\/([^\/]+)\/?$/;
    const match = url.match(regex);
    if (match) {
        const ticketId = match[1];
        return ticketId;
    }
    return false;
};

const getChatPermissionOfTicket = (ticketDetail) => {
    const chatPermission = ticketDetail.chatPermission;
    if(chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION){
        return {
            isByViewPermission : true,
            permission: ticketDetail.viewPermission
        }
    }else{
       return{ 
        isByViewPermission : false,
        permission: ticketDetail.chatPermission
       }
    }
}

const getCurrentUrlCaseLogin = (orgCode) => {
    let corporationDomain = localStorageUtil.getLastLoginCorpDomain();
    let contracTypeAndSubDomain = localStorageUtil.getContractTypeAndSubDomainCorp();
    contracTypeAndSubDomain = convertJSONDataToObject(contracTypeAndSubDomain);

    if(isEmptyObject(contracTypeAndSubDomain)) return `/${corporationDomain}`;
    
    let subDomainInvite = contracTypeAndSubDomain.subDomainInvite;
    let urlLink = corporationDomain ? corporationDomain : orgCode;

    switch (contracTypeAndSubDomain.contractType) {
        case Constant.CORPORATION_CONTRACT_TYPE.PREMIUM:
            return `/${urlLink}`;
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST:
            return `/${subDomainInvite}/c/${urlLink}`;
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK:
            return `/${subDomainInvite}/p/${urlLink}`;
        default:
            return `/${corporationDomain}`;
    }
}

const removeExcessZeros = input => {
    try {
        if (Utils.isEmptyString(input)) {
            return input;
        }

        const number = parseFloat(input);
        const isDecimal = /^[0-9]+\.[0-9]+$/;

        if (!isDecimal.test(number) && number !== 0) {
            const trimmedNumberString = input.replace(/^0+/, '');
            return trimmedNumberString;
        }
        return number.toString();
    } catch (err) {
        return input;
    }
};

const convertDecimalNumber = (convertNumber, fixed) =>  {
    if (Number.isFinite(convertNumber) && !Number.isInteger(convertNumber)) {
      return convertNumber.toFixed(fixed).replace(/\.?0+$/, '');
    } else {
      return convertNumber
    }
}

const sortListByOrderDesc = array => {
    if (Utils.isEmptyArray(array)) return [];
  
    return array.sort((a, b) => {
      const orderComparison = parseInt(b.order) - parseInt(a.order);
  
      if (orderComparison !== 0) {
        return orderComparison;
      } else {
        return new Date(b.updatedAt) - new Date(a.updatedAt);
      }
    });
}

function isNumber(value) {
    return /^\d+$/.test(value);
}

const checkNumberDecimal = (inputValue) => {
    const regexDecimal = /^[0-9]+(\.[0-9]+)?$/;
    if (!regexDecimal.test(inputValue)) {
        return trI18n('MSG-CM-WRONG-NUMBER-DOT-FORMAT');
    }
    if(inputValue.startsWith('0') && !inputValue.includes('.')) {
        return trI18n('MSG-CM-STORAGE-ERROR');
    }
    if(Utils.removeExcessZeros(inputValue) === "0") {
        return trI18n('MSG-CM-STORAGE-ERROR');
    }
    const [integerPart, decimalPart] = inputValue.split('.');
    if (
        (!Utils.isEmptyString(integerPart) && integerPart.length > 4) ||
        (!Utils.isEmptyString(decimalPart) && decimalPart.length > 3)
    ) {
        return trI18n('MSG-CM-STORAGE-ERROR');
    }

    return '';
}

const convertNumber = (number, toFixed = 0) => {
    const isDecimal = number.split('.');
    let newNumber = number;

    if (isDecimal.length > 1) {
        newNumber = convertDecimalNumber(number, toFixed);
    }

    if (number.startsWith('0') && isNumber(number)) {
        newNumber = BigInt(number).toString();
    }

    return newNumber;
}

const  areArraysEqual = (array1, array2) => {
    if (array1.length !== array2.length) {
        return false;
    }

    const sortedArray1 = array1.slice().sort();
    const sortedArray2 = array2.slice().sort();

    for (let i = 0; i < array1.length; i++) {
        if (sortedArray1[i] !== sortedArray2[i]) {
            return false;
        }
    }

    return true;
}

const getViewPermissionLabel = (viewPermission) => {

    const ONLY_CREATOR_PERMISSION_ITEM = {
        displayName: '投稿者',
        value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY
    };
    
    const IN_PROJECT_PERMISSION_ITEM = {
        displayName: 'プロジェクト内',
        value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT
    };
    
    const IN_ORG_PERMISSION_ITEM = {
        displayName: '組織内',
        value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG
    };
    
    const B2B_CUSTOMER_PERMISSION_ITEM = {
        displayName: '全B2Bカスタマープロジェクト',
        value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER
    };
    
    const B2B_SUPPORT_PERMISSION_ITEM = {
        displayName: '全B2Bサポートプロジェクト',
        value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT
    };
    
    const PUBLIC_PERMISSION_ITEM = {
        displayName: '一般公開',
        value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC
    };

    let listViewPermissionLabel = [];

    viewPermission.forEach(permission => {
        switch (permission) {
            case ONLY_CREATOR_PERMISSION_ITEM.value:
                listViewPermissionLabel.push(ONLY_CREATOR_PERMISSION_ITEM.displayName)
                break;
                case IN_PROJECT_PERMISSION_ITEM.value:
                    listViewPermissionLabel.push(IN_PROJECT_PERMISSION_ITEM.displayName)
                break;
                case IN_ORG_PERMISSION_ITEM.value:
                    listViewPermissionLabel.push(IN_ORG_PERMISSION_ITEM.displayName)
                break;
                case B2B_CUSTOMER_PERMISSION_ITEM.value:
                    listViewPermissionLabel.push(B2B_CUSTOMER_PERMISSION_ITEM.displayName)
                break;
                case B2B_SUPPORT_PERMISSION_ITEM.value:
                    listViewPermissionLabel.push(B2B_SUPPORT_PERMISSION_ITEM.displayName)
                break;
                case PUBLIC_PERMISSION_ITEM.value:
                    listViewPermissionLabel.push(PUBLIC_PERMISSION_ITEM.displayName)
                break;
        
            default:
                break;
        }
    })

    return listViewPermissionLabel
}

const isDisabledTicketExternalWhenDeskServiceOff = (ticket, corporation) => {
    if (
        corporation.deskService === Constant.STATUS_SERVICE_PERMISSION.OFF &&
        ticket.isExternalTicket &&
        (ticket.ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT ||
            ticket.ticketType === Constant.TICKET_TYPE.DELEGATE)
    ) {
        return true;
    }
    return false;
};

const checkUserPermissionKnowledgeService = (corpData, projectData) => {
    let userPermission = ''
    if (isEmptyObject(corpData) || isEmptyObject(projectData)) return userPermission;

    const contractType = corpData.contractType;
    switch (contractType) {
        case Constant.CORPORATION_CONTRACT_TYPE.PREMIUM:
            if (projectData.type === Constant.PROJECT_TYPE.GENERAL) {
                userPermission = Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT;
            }
            if (projectData.type === Constant.PROJECT_TYPE.BASE) {
                userPermission = Constant.USER_PERMISSION_VIEW_KNOWLEDGE.PERSONAL_PROJECT;
            }
            if (projectData.type === Constant.PROJECT_TYPE.CUSTOMER) {
                userPermission = Constant.USER_PERMISSION_VIEW_KNOWLEDGE.B2C;
            }
            break;
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST:
            userPermission = Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_SUPPORTED;
            break;
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK:
            userPermission = Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER;
            break;
        default:
            break;
    }
    return userPermission;
}

const getProjectName = (project) => {
    let projectName = convertJSONDataToObject(project.name);
    projectName = projectName ? projectName['jp']?.text : '';
    return projectName;
}

function arraysHaveSameElements(arr1, arr2) {
    return arr1.length === arr2.length && arr1.every(element => arr2.includes(element));
}

const isDisplaySplitPdfSwitch = (corporationDetail)=>{
    let isDisplay = false;

    if (Utils.isGuestContractType(corporationDetail)) {
        const inviterSettingObject = convertJSONDataToObject(corporationDetail.inviterSetting)
        if (inviterSettingObject.convertPDF === Constant.STATUS_SERVICE_PERMISSION.ON) isDisplay = true;
    } else {
        if (corporationDetail.limitValue?.convertPDF === Constant.STATUS_SERVICE_PERMISSION.ON) isDisplay = true;
    }
    return isDisplay
} 

const isNumeric = (num) => (typeof(num) === 'number' || typeof(num) === "string" && num.trim() !== '') && !isNaN(num);

function convertLatinNumberToJapaneseFullWidthNumber(latinNumber) {
    const latinDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const fullWidthJapaneseNumerals = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９'];

    const japaneseFullWidthNumber = latinNumber
        .toString()
        .split('')
        .map(digit => fullWidthJapaneseNumerals[latinDigits.indexOf(digit)])
        .join('');

    return japaneseFullWidthNumber;
}

function removeDigitsFromStringsArray(arr) {
    if (!arr || isEmptyArray(arr)) return [];

    for (let i = 0; i < arr.length; i++) {
      arr[i] = removeLatinAndJapaneseFullwidthNumbers(arr[i]);
    }
    
    return arr;
}

function removeLatinAndJapaneseFullwidthNumbers(input) {
    const regex = /[0-9０-９]/g;
    const result = input.replace(regex, '');
  
    return result.trim() || '';
}

function isJapaneseFullwidthNumber(text) {
    const japaneseFullwidthNumbers = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９'];

    for (let i = 0; i < text.length; i++) {
        if (!japaneseFullwidthNumbers.includes(text[i])) {
            return false;
        }
    }

    return true;
}

function convertJapaneseFullWidthNumberToLatinNumber(japaneseFullWidthNumber) {
    const latinDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const fullWidthJapaneseNumerals = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９'];

    const latinNumber = japaneseFullWidthNumber
        .toString()
        .split('')
        .map(digit => latinDigits[fullWidthJapaneseNumerals.indexOf(digit)])
        .join('');

    return latinNumber;
}

function isNameOrUrlOfPdfFile (url) {
    const pdfFileExtension = '.pdf'

    if(!url) return false
    return String(url).toLocaleLowerCase().endsWith(pdfFileExtension)
}

async function isUsingFunctionService (
    viewKnowledgeProjectSelected,
    corporationDetail,
    functionKey='',
    setUsingFunction
) {
    if (
        isEmptyObject(viewKnowledgeProjectSelected)
        || isEmptyString(functionKey)
        || isEmptyObject(corporationDetail)
    ) return false;

    let inviterSettingKey = functionKey;
    if (functionKey === 'knowledgeService') {
        inviterSettingKey = 'usingKnowledgeService'
    }

    if (
        viewKnowledgeProjectSelected.corporationId !== corporationDetail.id &&
        viewKnowledgeProjectSelected?.inviter !== corporationDetail.id
    ) {
        const corpRootBySelectedProject = await getCorporationById(null, viewKnowledgeProjectSelected.corporationId);
        if (!isEmptyObject(corpRootBySelectedProject)) {
            const limitValue = { ...corpRootBySelectedProject.limitValue };
            const newIsUsingFunction = limitValue?.[functionKey] === Constant.STATUS_SERVICE_PERMISSION.ON;
            setUsingFunction(newIsUsingFunction);
        }
        
    } else {
        if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)) {
            const newIsUsingFunction = convertJSONDataToObject(corporationDetail.inviterSetting)?.[inviterSettingKey] === Constant.STATUS_SERVICE_PERMISSION.ON;
            setUsingFunction(newIsUsingFunction);
        } else {
            const newIsUsingFunction = corporationDetail.limitValue?.[functionKey] === Constant.STATUS_SERVICE_PERMISSION.ON;
            setUsingFunction(newIsUsingFunction);
        }
    }
}


const setDefaultPermissionForSynonymForm = (formDetail) => {
    if (!formDetail) return {};

    let newFormDetail = {...formDetail};
    newFormDetail.viewPermission = [
        Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY,
        Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT
    ]
    newFormDetail.editPermission = [
        Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY,
        Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PROJECT_MANAGER
    ]
    newFormDetail.createTicketForOwnerPermission = [
        Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT
    ]
    newFormDetail.additionalCreateTicketForOwnerPermission = []
    newFormDetail.chatPermission = Constant.KNOWLEDGE_CHAT_PERMISSION.IN_PROJECT
    return newFormDetail;
}

//validate max size kbs;
const validateSizeOfFieldTicket = (value, maxSize = Constant.MAX_SIZE_KB_FIELD) => {
    let errorMessage = ''
    if(!value) return errorMessage;

    let fieldValue = JSON.stringify(value)

    const encoder = new TextEncoder();
    const utf8Bytes = encoder.encode(fieldValue);
    const sizeInKB = utf8Bytes.length / 1024;

    if(sizeInKB > maxSize) {
        errorMessage = trI18n('MSG-CM-OVER-MAX-CAPACITY').replace('{{max_capacity}}', '350KB');
    }
    return errorMessage;
}

// validate max size kbs for S3-stored text fields (markdown, json, etc.)
// Unlike validateSizeOfFieldTicket which JSON.stringifies the value (adding extra quotes for strings),
// this function measures the raw string byte size — matching backend getFieldValueByteSize logic.
const validateSizeOfS3TextField = (value, maxSize = Constant.MAX_SIZE_KB_FIELD) => {
    if (!value) return '';

    // Convert value to string the same way as backend convertFieldValueToString
    let fieldValueStr = '';
    switch (typeof value) {
        case 'string':
            fieldValueStr = value;
            break;
        case 'number':
        case 'boolean':
        case 'bigint':
            fieldValueStr = String(value);
            break;
        case 'object':
            fieldValueStr = JSON.stringify(value);
            break;
        default:
            fieldValueStr = String(value);
            break;
    }

    if (!fieldValueStr) return '';

    const encoder = new TextEncoder();
    const utf8Bytes = encoder.encode(fieldValueStr);
    const sizeInKB = utf8Bytes.length / 1024;

    if (sizeInKB > maxSize) {
        return trI18n('MSG-CM-OVER-MAX-CAPACITY').replace('{{max_capacity}}', '350KB');
    }
    return '';
}

const isValidLinkPromptInput = link => {
    let appDomain = process.env.REACT_APP_DOMAIN_NAME || '';

    if (appDomain.endsWith('/')) {
        appDomain = appDomain.slice(0, -1);
    }
    const urlRegex = new RegExp(
        `^${appDomain}\/share\/[a-z0-9-]+\/project_[a-z0-9-]+\/ticket\/knowledge_[0-9a-z-]+$`
    );

    return urlRegex.test(link.trim()) || isShortShareLink(link.trim());
};

const destructLinkPrompt = linkInput => {
    if(!linkInput) return '';
    
    const destructLink = linkInput.split('/');
    if (destructLink.length !== 8) {
        return '';
    }

    const uriTicketId = destructLink[7];
    return uriTicketId
};

const createTagForLogKibana = (drillDownDataSelected) => {
    let listTagSuggest = [];
    if (drillDownDataSelected.length > 0) {
        for (let i = 0; i < drillDownDataSelected.length; i++) {
            let fieldLabel = drillDownDataSelected[i].fieldLabel;
            let itemLabel = drillDownDataSelected[i].itemLabel;
            listTagSuggest.push( itemLabel + '@' + fieldLabel);
        }
    }
    return listTagSuggest;
}

export const validateStyleSheet = value => {
    if(Utils.isEmptyString(value.trim())) return 'COMMSG014';
    if (value.length > 200000) return 'MSG-CM-OVER-MAXLENGTH';

    return '';
};

const isValidUrl = (url) => {
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
};

export const getShareLinkUrls = (content) => {
    const text = `${content}`;
    const urlRegex = /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g;
    const urls = text.match(urlRegex) || [];
    if (Utils.isEmptyArray(urls)) return [];

    let validUrls = urls.filter(url => {
        if (!isValidUrl(url)) return false;
        if (isShortShareLink(url)) return true;

        try {
            const urlPathName = new URL(url).pathname;
            const matchUrl = matchPath(urlPathName, {
                path: Constant.SHARE_TICKET_ROUTER,
                exact: true,
                strict: true
            });
    
    
            return !Utils.isEmptyObject(matchUrl) ? matchUrl.isExact : false
        } catch (error) {
            console.log('getShareLinkUrls err ', {error, url});
            return false;
        }
    });

    return validUrls;
};
const convertByteToMB  = (bytes)=>{
    return Number(bytes) / (1024 * 1024) // 1MB = 1024 kilobyte = 1024 * 1024 byte
}

const splitArrayIntoSubArrays = (array, chunkSize) => {
    return array.reduce((acc, _, index) => {
        if (index % chunkSize === 0) {
            acc.push(array.slice(index, index + chunkSize));
        }
        return acc;
    }, []);
};

const sortByExecuteTimeAtDesc = arr => {
    if (isEmptyArray(arr)) {
        return [];
    }
    return arr.sort((a, b) => {
        return new Date(b.executeTime) - new Date(a.executeTime);
    });
};

const generateRandomStr = () => {
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let str = '';
    for (let i = 0; i < 30; i++) {
        str += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return str;
};

const getUniqueObjectListInArray = (objectsArray) => {
    if (isEmptyArray(objectsArray)) return [];
    let uniqueObjectsArray = [];
    let uniqueObjectsSet = new Set();

    objectsArray.forEach(obj => {
        let jsonString = JSON.stringify(obj);
        if (!uniqueObjectsSet.has(jsonString)) {
            uniqueObjectsSet.add(jsonString);
            uniqueObjectsArray.push(obj);
        }
    });

    return uniqueObjectsArray;
}

const filterDuplicates = (arr)=> {
    // Sử dụng Set để lọc các phần tử duy nhất
    let uniqueItems = new Set(arr);

    // Chuyển đổi Set thành mảng bằng cách sử dụng spread operator
    let uniqueArray = [...uniqueItems];

    return uniqueArray;
}

const initKeyFileSaveLogBulkAction = (
    corporationId,
    userId,
    fileName,
    logTicketType = Constant.BULK_ACTION_LOG_TICKET_TYPE.KNOWLEDGE,
    projectId,
    logObject
) => {
    let s3Key = '';

    switch (logTicketType) {
        case Constant.BULK_ACTION_LOG_TICKET_TYPE.KNOWLEDGE:
            s3Key = `${corporationId}/${projectId}/BulkActionLog/${userId}/${fileName}`;
            break;
        case Constant.BULK_ACTION_LOG_TICKET_TYPE.HELPDESK:
            s3Key = `${corporationId}/${projectId}/BulkActionLog/helpdesk/${userId}/${fileName}`;
            break;
        default:
            return '';
    }
    if (logObject) {
         s3Key = `${corporationId}/${projectId}/uploadTagItem/${userId}/${fileName}`;
    }

    return s3Key;
};

const isAnonymousQATicketFromChatBotAndFinish = ticket => {
    if (ticket?.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT) {
        return true;
    }
    return false;
};

const isAnonymousQATicketFromIframe = ticket => {
    if (ticket?.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.IFRAME || 
        (ticket?.customer === Constant.ANONYMOUS_USER_ID && !isAnonymousQATicketFromChatBotAndFinish(ticket) && !isAnonymousQATicketFromLiveChat(ticket))
    ) {
        return true;
    }
    return false;
};

const isStringOverLength = (myString, size = 50) => {
    return myString?.length > size;
};

const getCurrentDevice = () => {
    if (window.innerWidth >= Constant.PANEL_RESPONSIVE.PC) {
        return Constant.SCREEN_DEVICE.DESKTOP
    }
    if (window.innerWidth >= Constant.PANEL_RESPONSIVE.MOBILE && window.innerWidth < Constant.PANEL_RESPONSIVE.PC) {
        return Constant.SCREEN_DEVICE.TABLET;
    } 

    return Constant.SCREEN_DEVICE.MOBILE;
}

/**
 * Detect whether the real device is a mobile or tablet based on user agent.
 * Unlike getCurrentDevice (which relies on window.innerWidth and is affected by
 * browser zoom / window width), this check is independent of screen size.
 * iPadOS 13+ Safari reports a desktop-like user agent, so it is detected via
 * the Macintosh token combined with touch support (maxTouchPoints > 1).
 * @returns {boolean} true if the device is a mobile or tablet
 */
const isMobileOrTabletDevice = () => {
    const userAgent = navigator.userAgent || '';
    const isIpadOS = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;
    const isTablet = /iPad/i.test(userAgent) || isIpadOS || (/Android/i.test(userAgent) && !/Mobile/i.test(userAgent));
    const isMobile = /Mobi|iPhone|iPod|Android.*Mobile|Windows Phone/i.test(userAgent);
    return isMobile || isTablet;
};

/**
 * delay function
 * @param {*} ms 
 * @returns 
 */
function delay(ms = 0) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const getArrByBreakline = (string) => {
    if (isEmptyString(string)) return [];
    return string.split(Constant.BREAKLINE_REGEX);
}

const validIpAddressFormat = (ip) => {
    if (isEmptyString(ip)) return false;
    return Constant.IPV4_FORMAT_REGEX.test(ip);
}

const isNumberExludeStartZero = (str) => {
    if (isEmptyString(str)) return false;
    if (!Constant.NUMBER_REGEX.test(str)) return false;
    if (str.startsWith('0')) return false;
    return true;
}

const findDuplicateData = arr => arr.filter((item, index) => arr.indexOf(item) !== index);

const isEnableCreateEmailTicketMode = (corporationDetail, projectInuseDetail) => {
    if (isEmptyObject(corporationDetail) || isEmptyObject(projectInuseDetail)) return false;
    let mailSetting = projectInuseDetail?.mailSetting ? convertJSONDataToObject(projectInuseDetail?.mailSetting) : {};
    let isCorporationOnEmailTicketMode = false;
    let isProjectOnEmailTicketMode = mailSetting?.isEmailResponseSettingFunction;

    if([Constant.CORPORATION_CONTRACT_TYPE.GUEST,Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)){
        const inviterSetting = convertJSONDataToObject(corporationDetail.inviterSetting);
        isCorporationOnEmailTicketMode = inviterSetting.emailResponseFunction;
    } else {
        isCorporationOnEmailTicketMode = corporationDetail?.limitValue?.emailResponseFunction
    }
    
    let isOnEmailTicketMode = isCorporationOnEmailTicketMode && isProjectOnEmailTicketMode && isPublicDesk(projectInuseDetail);

    return isOnEmailTicketMode ? true : false;
}

/**
 * Telephone agent depends on AI Auto: it is only available while AI Auto is ON.
 */
const isEnableSettingTelephoneAgent = (corporationDetail) => {
    if (isEmptyObject(corporationDetail)) return false;
    
    let isCorporationOnUsingTelephoneAgent = false;
    if([Constant.CORPORATION_CONTRACT_TYPE.GUEST,Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)){
        const inviterSetting = convertJSONDataToObject(corporationDetail.inviterSetting);
        isCorporationOnUsingTelephoneAgent = inviterSetting.usingTelephoneAgent === Constant.STATUS_SERVICE_PERMISSION.ON &&
            inviterSetting.telephoneAgent === Constant.STATUS_SERVICE_PERMISSION.ON &&
            inviterSetting.usingAIAuto === Constant.STATUS_SERVICE_PERMISSION.ON &&
            inviterSetting.aiAuto === Constant.STATUS_SERVICE_PERMISSION.ON;
    } else {
        const hasTelephoneAgentPermission = corporationDetail?.limitValue?.telephoneAgent === Constant.STATUS_SERVICE_PERMISSION.ON;
        const hasTelephoneAgentSetting = corporationDetail?.limitValue?.usingTelephoneAgent === Constant.STATUS_SERVICE_PERMISSION.ON;
        const hasAIAutoOn = corporationDetail?.limitValue?.aiAuto === Constant.STATUS_SERVICE_PERMISSION.ON &&
            corporationDetail?.limitValue?.usingAIAuto === Constant.STATUS_SERVICE_PERMISSION.ON;
        
        isCorporationOnUsingTelephoneAgent = hasTelephoneAgentPermission && hasTelephoneAgentSetting && hasAIAutoOn;
    }

    return isCorporationOnUsingTelephoneAgent;
}

const isEnableUsingTelephoneMode = (corporationDetail) => {
    return isEnableSettingTelephoneAgent(corporationDetail);
}

/**
 * Check if the project itself allows external phone call.
 * Reads the「外部電話発信」toggle at Project Information, which is only configurable
 * on a public desk project (DESK_ON_PUBLIC_ON). Guest desk (partner) is always allowed.
 * @param {Object} projectDetail - Project detail object
 * @returns {boolean}
 */
const isProjectOnExternalPhoneCall = (projectDetail) => {
    if (isEmptyObject(projectDetail) || !projectDetail.projectSetting) return false;
    if (isProjectGuestDesk(projectDetail)) return true;

    const projectSetting = convertJSONDataToObject(projectDetail.projectSetting);
    return Boolean(projectSetting?.telephoneAgentSetting?.isUsingTelephoneAgent);
};

/**
 * Check if external phone call is enabled for both organization and project.
 * Non premium contract only depends on the organization setting because the project
 * toggle is not available for them.
 * @param {Object} corporationDetail - Corporation detail object
 * @param {Object} projectDetail - Project detail object
 * @returns {boolean}
 */
const isEnableExternalPhoneCall = (corporationDetail, projectDetail) => {
    const isEnableOnCorporation = isEnableSettingTelephoneAgent(corporationDetail);
    if (corporationDetail?.contractType !== Constant.CORPORATION_CONTRACT_TYPE.PREMIUM) return isEnableOnCorporation;

    if (isEmptyObject(projectDetail)) return false;
    return isProjectOnExternalPhoneCall(projectDetail) && isEnableOnCorporation;
};

const isEnableCreateEmailTicketModeOnSkipProjectType = (corporationDetail, projectInuseDetail) => {
    if (isEmptyObject(corporationDetail) || isEmptyObject(projectInuseDetail)) return false;
    let mailSetting = projectInuseDetail?.mailSetting ? convertJSONDataToObject(projectInuseDetail?.mailSetting) : {};
    let isCorporationOnEmailTicketMode = false;
    let isProjectOnEmailTicketMode = mailSetting?.isEmailResponseSettingFunction;

    if([Constant.CORPORATION_CONTRACT_TYPE.GUEST,Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)){
        const inviterSetting = convertJSONDataToObject(corporationDetail.inviterSetting);
        isCorporationOnEmailTicketMode = inviterSetting.emailResponseFunction;
    } else {
        isCorporationOnEmailTicketMode = corporationDetail?.limitValue?.emailResponseFunction
    }
    
    let isOnEmailTicketMode = isCorporationOnEmailTicketMode && isProjectOnEmailTicketMode;

    return isOnEmailTicketMode ? true : false;
}

const chunkArray = (myArray, chunkSize) => {
    var results = [];

    while (myArray.length) {
        results.push(myArray.splice(0, chunkSize));
    }

    return results;
}

const getEmailDomain = () => {
    let domain = process.env.REACT_APP_DOMAIN_NAME;
    if (!domain) return '';
    let allowDomain = [
        'dbdesk-test.ominext.dev',
        'solutiondesk.jp',
        'dbdesk-staging.ominext.dev',
        'dbdesk-prestaging.ominext.dev'
    ]
    let fixDomain = 'dbdesk-dev.ominext.dev';
    const cleanUrl = domain.replace(/^https?:\/\//, '').replace(/\//g, '');
    if (allowDomain.includes(cleanUrl)) {
        return cleanUrl;
    }
    return fixDomain;
}

const isDisableEditEmailTicket = (ticketDetail, projectInuseDetail, corporationDetail, statusNo) => {
    if (isEmptyObject(ticketDetail) || isEmptyObject(projectInuseDetail) || isEmptyObject(corporationDetail) || !statusNo) return false;
    if (ticketDetail.ticketType === Constant.TICKET_TYPE.EMAIL && !isEnableCreateEmailTicketMode(corporationDetail, projectInuseDetail) && statusNo === Constant.STATUS_NO.DONE) {
        return true;
    }

    return false;
}

const unEscapeHtml = (string, isKeepHtml = false) => {
    if (!string) return '';
    
    if(!isKeepHtml) string = string.replace(/(<([^>]+)>)/gi, '');
    
    return string
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&nbsp;/g, ' ')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&#039;/g, "'")
        .replace(/\\"/g, '"')
        .replace(/\\\\"/g, '"');
}

const isSystemFormChatAIPrompt = formDetail => {
    if (isEmptyObject(formDetail)) return false;
    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        formDetail.type === Constant.FORM_TYPE.FORM_KNOWLEDGE &&
        formDetail.promptKnowledgeFormFlag === Constant.PROMPT_FLAG.TRUE &&
        !formDetail.definitionVariant
    );
};

const isSystemAIAutoForm = formDetail => {
    if (isEmptyObject(formDetail)) return false;

    const DEFINITION_VARIANT_AI_AUTO = [
        Constant.FORM_VARIANT.AI_AUTO.EVENT,
        Constant.FORM_VARIANT.AI_AUTO.TIMER,
        Constant.FORM_VARIANT.AI_AUTO.PERIODIC
    ];

    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        DEFINITION_VARIANT_AI_AUTO.includes(formDetail?.definitionVariant)
    );
};

const isSystemAIAutoEventForm = formDetail => {
    if (isEmptyObject(formDetail)) return false;
    
    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        formDetail?.definitionVariant === Constant.FORM_VARIANT.AI_AUTO.EVENT
    );
}

const isSystemSDAutoForm = formDetail => {
    if (isEmptyObject(formDetail)) return false;

    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
       formDetail?.definitionVariant === Constant.FORM_VARIANT.SD_AUTO
    );
};

const isSystemTelephoneForm = formDetail => {
    if (isEmptyObject(formDetail)) return false;

    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        formDetail?.definitionVariant === Constant.FORM_VARIANT.TELEPHONE_FORMAT
    );
};

const isProjectOnPhoneSupport = projectDetail => {
    if (!projectDetail || !projectDetail.projectSetting) return false;
    if (projectDetail?.projectInvite && !Utils.isEmptyString(projectDetail?.projectInvite)) return true;

    const projectSetting = convertJSONDataToObject(projectDetail.projectSetting);
    return projectSetting?.telephoneAgentSetting?.isUsingTelephoneAgent === true;
};

const isSystemBusinessAppForm = formDetail => {
    if (isEmptyObject(formDetail)) return false;

    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
       formDetail?.definitionVariant === Constant.FORM_VARIANT.BUSINESS_APP
    );
};

const isSystemTelephoneAgentForm = formDetail => {
    if (isEmptyObject(formDetail)) return false;

    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        formDetail?.definitionVariant === Constant.FORM_VARIANT.TELEPHONE_FORMAT
    );
};

/**
 * Check if form is KB Knowledge format
 * @param {Object} formDetail - Form detail object
 * @returns {boolean} - True if KB Knowledge format
 */
const isSystemKBoardKnowledgeForm = formDetail => {
    if (isEmptyObject(formDetail)) return false;

    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        formDetail.definitionVariant === Constant.FORM_VARIANT.KB_KNOWLEDGE
    );
};

const isSystemFormAITelephonePrompt = formDetail => {
    if (isEmptyObject(formDetail)) return false;
    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        formDetail.type === Constant.FORM_TYPE.FORM_KNOWLEDGE &&
        formDetail.promptKnowledgeFormFlag === Constant.PROMPT_FLAG.TRUE &&
        formDetail.definitionVariant === Constant.FORM_VARIANT.AI_TELEPHONE_PROMPT
    );
};

const isSystemFormAIAssistantPrompt = formDetail => {
    if (isEmptyObject(formDetail)) return false;
    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        formDetail.type === Constant.FORM_TYPE.FORM_KNOWLEDGE &&
        formDetail.promptKnowledgeFormFlag === Constant.PROMPT_FLAG.TRUE &&
        formDetail.definitionVariant === Constant.FORM_VARIANT.AI_ASSISTANT_PROMPT
    );
};

const isSystemFormAITrainingPrompt = formDetail => {
    if (isEmptyObject(formDetail)) return false;
    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        formDetail.type === Constant.FORM_TYPE.FORM_KNOWLEDGE &&
        formDetail.promptKnowledgeFormFlag === Constant.PROMPT_FLAG.TRUE &&
        formDetail.definitionVariant === Constant.FORM_VARIANT.AI_TRAINING_PROMPT
    );
};

const isSystemFormKBoardPrompt = formDetail => {
    if (isEmptyObject(formDetail)) return false;
    return (
        formDetail.definition === Constant.FORM_DEFINITION.SYSTEM &&
        formDetail.type === Constant.FORM_TYPE.FORM_KNOWLEDGE &&
        formDetail.promptKnowledgeFormFlag === Constant.PROMPT_FLAG.TRUE &&
        formDetail.definitionVariant === Constant.FORM_VARIANT.KBOARD_PROMPT
    );
};

const isCorporationOnAI = corporationDetail => {
    let status = false;
    if (isGuestContractType(corporationDetail)) {
        if (corporationDetail?.inviterUsingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON)
            status = true;
    } else {
        if (
            corporationDetail?.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON &&
            corporationDetail?.limitValue?.chatAI === Constant.STATUS_SERVICE_PERMISSION.ON
        )
            status = true;
    }
    return status;
};

const isCorporationOnAIAuto = corporationDetail => {
    if (corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST) {
        return false;
    }
    
    const isUsingAIAuto = corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
        ? (
            convertJSONDataToObject(corporationDetail.inviterSetting)?.usingAIAuto === Constant.STATUS_SERVICE_PERMISSION.ON &&
            convertJSONDataToObject(corporationDetail.inviterSetting)?.aiAuto === Constant.STATUS_SERVICE_PERMISSION.ON
        )
        : (corporationDetail?.limitValue?.usingAIAuto === Constant.STATUS_SERVICE_PERMISSION.ON && corporationDetail?.limitValue?.aiAuto === Constant.STATUS_SERVICE_PERMISSION.ON);
    return isUsingAIAuto && isCorporationOnKnowledge(corporationDetail);
};

const isCorporationOnSDAuto = corporationDetail => {
    if (corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST) {
        return false;
    }

    const isUsingSDAuto =
        corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
            ? convertJSONDataToObject(corporationDetail.inviterSetting)?.usingSDAuto ===
                  Constant.STATUS_SERVICE_PERMISSION.ON &&
              convertJSONDataToObject(corporationDetail.inviterSetting)?.sdAuto ===
                  Constant.STATUS_SERVICE_PERMISSION.ON
            : corporationDetail?.limitValue?.usingSDAuto ===
                  Constant.STATUS_SERVICE_PERMISSION.ON &&
              corporationDetail?.limitValue?.sdAuto === Constant.STATUS_SERVICE_PERMISSION.ON;
              
    return isUsingSDAuto && isCorporationOnKnowledge(corporationDetail);
};

const isProjectOnTelephoneSupport = projectDetail => {
    return true
    if (isEmptyObject(projectDetail) || !projectDetail.projectSetting) {
        return false;
    }
    
    let projectSetting = {};
    try {
        projectSetting = typeof projectDetail.projectSetting === 'string' 
            ? convertJSONDataToObject(projectDetail.projectSetting)
            : projectDetail.projectSetting;
    } catch (error) {
        console.error('Error parsing projectSetting:', error);
        return false;
    }
    
    return projectSetting.telephoneAgent === Constant.STATUS_SERVICE_PERMISSION.ON 
        || projectSetting.telephoneAgent === 1;
};

const isCorporationOnKnowledge = corporationDetail => {
    let status = false;
    if (isGuestContractType(corporationDetail)) {
        const inviterSetting = convertJSONDataToObject(corporationDetail.inviterSetting);

        if (inviterSetting?.usingKnowledgeService === Constant.ACTIVE_FLAG.ACTIVE) status = true;
    } else {
        if (corporationDetail?.knowledgeService === Constant.ACTIVE_FLAG.ACTIVE) status = true;
    }
    return status;
};

const isCorporationOnKBoardPrompt = corporationDetail => {
    if (!isCorporationOnKnowledge(corporationDetail)) return false;

    if (isGuestContractType(corporationDetail)) {
        const inviterSetting = convertJSONDataToObject(corporationDetail?.inviterSetting);
        return (
            inviterSetting?.kBoard === Constant.STATUS_SERVICE_PERMISSION.ON &&
            inviterSetting?.usingKBoard === Constant.STATUS_SERVICE_PERMISSION.ON
        );
    }

    return (
        corporationDetail?.limitValue?.usingKBoard === Constant.STATUS_SERVICE_PERMISSION.ON &&
        corporationDetail?.limitValue?.kBoard === Constant.STATUS_SERVICE_PERMISSION.ON
    );
};

const isDisplayHelpdeskTicketList = (projectInuseDetail) => {
    const isDisplayNone = Utils.isProjectGuest(projectInuseDetail) ||
        [Constant.PROJECT_TYPE.BASE, Constant.PROJECT_TYPE.CUSTOMER].includes(projectInuseDetail?.type)
    return !isDisplayNone;
}

const shouldShowPhoneIcon = (corporationDetail, projectDetail, ticketListType) => {
    // Check if projectDetail and corporationDetail are valid
    if (isEmptyObject(projectDetail) || isEmptyObject(corporationDetail)) {
        return false;
    }

    if(
        [Constant.CORPORATION_CONTRACT_TYPE.GUEST,Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail?.contractType)
    ) {
        return false;
    }

    if (projectDetail?.type === Constant.PROJECT_TYPE.CUSTOMER) {
        return false;
    }

    const isEnableUsingTelephone = isEnableSettingTelephoneAgent(corporationDetail);
    
    if (ticketListType === Constant.TYPE_GET_TICKET_LIST.HELPDESK) {
        return isEnableUsingTelephone;
    }

    if (ticketListType === Constant.TYPE_GET_TICKET_LIST.CUSTOMER) {
        const isDisplayHelpdesk = isDisplayHelpdeskTicketList(projectDetail);
        return !isDisplayHelpdesk && isEnableUsingTelephone;
    }

    return false;
};

function removeDoubleQuotes(str) {
    if (str.startsWith('"') && str.endsWith('"')) {
        return str.slice(1, -1);
    }
    return str;
}

const validateDateByMinutesStep = (dateValue = new Date(), minutesStep = 1) => {
    const result = {
        status: true,
        errorMessage: ''
    };
    try {
        if(isEmptyString(dateValue)) {
            result.status = false;
            result.errorMessage = trI18n('COMMSG014');
            return result;
        }
        // Chuyển đổi giá trị fieldValue thành Date
        const date = new Date(dateValue);
        // Kiểm tra giá trị phút
        const minutes = date.getMinutes();
        if (Number(minutes) % Number(minutesStep) !== 0) {
            result.status = false;
            result.errorMessage = trI18n('MSG-AI-INVALID-PROMPT-EXECUTION-DATETIME');
            return result;
        }
        return result;
    } catch (error) {
        return result;
    }
};

const getUserEmailAfterDeleted = (userEmail) => {
    if (!userEmail) return '';
    return `${userEmail}${Constant.DELETED_USER_EMAIL_SUFFIX}`;
}

const getDisplayUserEmailWithoutSuffix = (mail) => {
    if (!mail) return '';

    if (mail.endsWith(Constant.DELETED_USER_EMAIL_SUFFIX)) {
        return mail.replace(Constant.DELETED_USER_EMAIL_SUFFIX, '');
    }

    return mail;
}

const handlePreviewHtmlSource = (htmlString) => {
    // Remove all script tags
    htmlString = htmlString.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');
    // Handle something
    return htmlString;
}

const buildHtmlFieldValueS3Key = (ticketId, fieldId, affiliationOrganization, affiliationProject) => {
    if (!ticketId || !fieldId || !affiliationOrganization) return;
    return `public/assets/html/${affiliationOrganization}/ticket/${ticketId}/${fieldId}.html`;
}


const buildJsonFieldValueS3Key = (ticketId, fieldId, affiliationOrganization) => {
    if (!ticketId || !fieldId || !affiliationOrganization) return;
    return `public/assets/no-cache/json/${affiliationOrganization}/ticket/${ticketId}/${fieldId}.json`;
}


const buildHtmlShareLinkPage = (ticketId, fieldId) => {
    if (!ticketId || !fieldId) return;

    return `${window.location.origin}/share/html/${ticketId}/${fieldId}`;
}
const buildScriptFieldValueS3Key = (ticketId, fieldId, affiliationOrganization) => {
    if (!ticketId || !fieldId || !affiliationOrganization) return;
    return `public/assets/script/${affiliationOrganization}/ticket/${ticketId}/${fieldId}`;
}

const buildMarkdownFieldValueS3Key = (ticketId, fieldId, affiliationOrganization) => {
    if (!ticketId || !fieldId || !affiliationOrganization) return;
    return `public/assets/no-cache/markdown/${affiliationOrganization}/ticket/${ticketId}/${fieldId}.md`;
}

const cleanHtml = htmlString => {
    if (!htmlString) return '';
    return htmlString.replace(/<[^>]*>?/gm, '');
};

const getRichTextUrls = (stage, richtextValue)=>{
    if (!richtextValue) {
            return [];
        }
        
        let urlRegex = /(https?:\/\/(cdn|newcdn)-badesk[^\s"']*)/g;
        if (stage === 'prod') {
            urlRegex = /(https?:\/\/cdn.solutiondesk.jp[^\s"']*)/g;
        }
        const urls = new RegExp(urlRegex, 'g');
        let result = richtextValue.match(urls)?.length ? richtextValue.match(urls) : [];
        try {
            const richtextValueObj = convertJSONDataToObject(richtextValue);
            if (richtextValueObj?.hasOwnProperty('value')) {
                result = richtextValueObj?.value?.match(urls)?.length
                    ? richtextValueObj?.value?.match(urls)
                    : [];
            }
        } catch (error) {
            console.log('getRichTextUrls throw error  :>> ', error);
        }
        return result?.map(i=> i?.replace(/\\/g, ''));
}

const getKeyFileFromCDNLinks = (urls) => {
    const results = [];
    const domain = process.env.REACT_APP_CLOUD_FRONT_URL
    urls.forEach(url => {
        const params = url
            .replace(domain, '')
            .replace('\\"', '')
            .replace('\\\\', '')
            .split('/');
        const endCodeRequestParam = CryptoJS.AES.decrypt(
            decodeURIComponent(params[1]),
            encodeKey
        ).toString(CryptoJS.enc.Utf8);
        if (endCodeRequestParam) {
            const datas = convertJSONDataToObject(endCodeRequestParam);
            results.push({ keyFile: datas.keyFile || '', url: url });
        }
    });
    return results;
};

/**
 * isGroupQATicketType
 * @param {*} ticketDetail 
 * @returns 
 */
const isGroupQATicketType = ticketDetail => {
    if (isEmptyObject(ticketDetail)) return false;

    let isQATicketType = false;
    switch (ticketDetail.ticketType) {
        case Constant.TICKET_TYPE.QA:
        case Constant.TICKET_TYPE.DELEGATE:
        case Constant.TICKET_TYPE.ESCALATION:
        case Constant.TICKET_TYPE.INTERNAL_QA:
        case Constant.TICKET_TYPE.EXTERNAL_QA:
            isQATicketType = true;
            break;
        default:
            break;
    }

    return isQATicketType;
};

const extractShareLinkInfo = async url => {
    let processUrl = url;
    if (isShortShareLink(url)) {
        const shortKey = new URL(url, process.env.REACT_APP_DOMAIN_NAME).pathname.slice(-7);
        const result = await getPublicAPI(null, {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_DATA_SHARE_LINK_BY_SHORT_KEY,
            shortKey
        });
        const dataShareLink = Utils.convertJSONDataToObject(result.payload);
        if (Utils.isEmptyObject(dataShareLink)) {
            console.log('extractShareLinkInfo error url: ', url);
            return {};
        }
        processUrl = `/share/${dataShareLink.generateLinkCorporationDomain}/${dataShareLink.generateLinkProjectId}/ticket/${dataShareLink.targetId}`;
    }
    // Tạo một biểu thức chính quy để khớp với mẫu URL
    const pattern = /\/share\/([^\/]+)\/([^\/]+)\/ticket\/([^\/]+)/;

    // Sử dụng biểu thức chính quy để kiểm tra và trích xuất các tham số từ URL
    const match = processUrl.match(pattern);

    if (match) {
        try {
            const urlObj = new URL(url, process.env.REACT_APP_DOMAIN_NAME);
            const withMessage = urlObj.searchParams.get('with_message');
            const result = {
                orgDomain: match[1],
                projectId: match[2],
                ticketId: match[3].split('?')[0]
            };

            if (withMessage) {
                result.withMessage = withMessage;
            }

            return result;
        } catch (error) {
            console.log('extractShareLinkInfo error url: ', {error, url});
            return {};
        }
    }
    return {};
};

const convertTimeToLocalYYYY_MM_DD_HH_MM_SS = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);

    const YYYY = date.getFullYear();
    const MM = String(date.getMonth() + 1).padStart(2, '0');
    const DD = String(date.getDate()).padStart(2, '0');

    const HH = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');

    return `${YYYY}/${MM}/${DD} ${HH}:${mm}:${ss}`;
};

const getJSTDateTimeYYYY_MM_DDHHMM = dateTimeString => {
    let dateTime = moment_timezone.utc(dateTimeString).tz('Asia/Tokyo');
    return dateTime.format('YYYY/MM/DD HH:mm');
};

const getBookmarkTargetTypeByTicketType = (ticketType) => {
    let targetType = Constant.BOOKMARK_TARGET_TYPE.TICKET;
    if (!ticketType) return targetType;

    const isKnowledge = [
        Constant.TICKET_TYPE.KNOWLEDGE,
        Constant.TICKET_TYPE.MASTER_KNOWLEDGE,
        Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE,
        Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE,
    ].includes(Number(ticketType))

    if (isKnowledge) {
        return Constant.BOOKMARK_TARGET_TYPE.KNOWLEDGE;
    }
    
    return targetType;
};

const isBase62 = (str) => {
    const base62Regex = /^[0-9a-zA-Z]+$/;
    return base62Regex.test(str);
}

const isShortShareLink = url => {
    const REGEX_CHECK_SHORT_SHARE_LINK_VALID = /^https?:\/\/[^\/]+\/share\/[^\/]+\/[TKP]\/[A-Za-z0-9]{7}(\?.*)?$/;
    return REGEX_CHECK_SHORT_SHARE_LINK_VALID.test(url);
};

const isShortLinkAttachFile = url => {
    const REGEX_CHECK_SHARE_LINK_ATTACH_FILE = /^https?:\/\/[^\/]+\/share\/[^\/]+\/[TKP]\/[A-Za-z0-9]{7}\/(?:att_[A-Za-z0-9]+|msg_att_[A-Za-z0-9]+)$/
    return REGEX_CHECK_SHARE_LINK_ATTACH_FILE.test(url);
}

const getTicketIdByShareLink = async link => {
    const shortKey = link.slice(-7);
    let idTicket = link.split('/').pop();

    if (Utils.isShortShareLink(link)) {
        const result = await getPublicAPI(null, {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_DATA_SHARE_LINK_BY_SHORT_KEY,
            shortKey
        });
        const dataShareLink = Utils.convertJSONDataToObject(result.payload);
        if (!Utils.isEmptyObject(dataShareLink)) {
            idTicket = dataShareLink.targetId;
        }
    }

    return idTicket;
};

const generateS3LinkCodeSDScript = (ticketId, fieldId) => {
    if (!ticketId || !fieldId) return;
    return `${window.location.origin}/share/sdscript/${ticketId}/${fieldId}`;
};

const isValidAlphaNumericUnderscore = str => {
    const regex = /^[a-zA-Z0-9_]+$/;
    return regex.test(str);
};

const setFocusedMsgId = (ticketId, msgId) => {
    if (msgId) {
        if (getPrefixOfId(ticketId) === Constant.TICKET_PREFIX.KNOWLEDGE) {
            sessionStorageUtil.setFocusedMsgIdKL(msgId);
        } else {
            sessionStorageUtil.setFocusedMsgIdTicket(msgId);
        }
    } else {
        sessionStorageUtil.deleteFocusedMsgIdKL();
        sessionStorageUtil.deleteFocusedMsgIdTicket();
    }
};

const parseDate = ({ value, format }) => {
    return value ? moment(value, format) : null
}

const isCorporationOnMfa = corporationDetail => {
    if (
        [
            Constant.CORPORATION_CONTRACT_TYPE.GUEST,
            Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
        ].includes(corporationDetail.contractType)
    ) {
        return false;
    }
    const corporationSetting = convertJSONDataToObject(corporationDetail?.corporationSetting);
    const limitValue = convertJSONDataToObject(corporationDetail?.limitValue);

    return (
        corporationSetting?.usingMultiAuth === true &&
        limitValue?.multiAuth === Constant.STATUS_SERVICE_PERMISSION.ON
    );
};


const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return '0 B'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

const generateAttachmentShareLink = (ticketShareLink, attachmentData) => {
    if (!ticketShareLink || isEmptyObject(attachmentData)) return '';

    let attachKey = '';
    if (attachmentData?.attachBy === Constant.ATTACH_FILE_TYPE.CHAT) {
        attachKey = `msg_att_${attachmentData?.shortKey}`;
    } else {
        attachKey = `att_${attachmentData?.shortKey}`;
    }

    return `${ticketShareLink}/${attachKey}`;
}

const getShareLinkImg = ({ dataShareLink, attachFile }) => {
    if (!Utils.isEmptyObject(dataShareLink) && !Utils.isEmptyObject(attachFile)) {
        return `${process.env.REACT_APP_CLOUD_FRONT_URL}/${Utils.getUrlShortShareLinkTicket({
            type: dataShareLink?.type,
            shortKey: dataShareLink?.shortKey,
            subDomain: dataShareLink?.generateLinkCorporationDomain
        })}/${attachFile?.originId?.includes('post') ? 'msg_att' : 'att'}_${attachFile?.shortKey}`;
    }
};


const isEqualArray = (array1, array2) => {
    if (array1.length !== array2.length) return false;
    return array1.every((item, index) => item === array2[index]);
}

const transformAuthMethod = authMethod => {
    const { OAUTH2, JWT, BASE, NONE, BEARER, APIKEY } = Constant.AUTH_METHOD_MCP_SERVER;
    const BACKEND_VALUES = [OAUTH2, JWT, BASE, NONE, BEARER, APIKEY];
    const FRONTEND_VALUES = [
        Constant.AUTH_METHOD_MCP_SERVER.OAUTH2_SETTING,
        Constant.AUTH_METHOD_MCP_SERVER.JWT_SETTING,
        Constant.AUTH_METHOD_MCP_SERVER.BASE_SETTING,
        Constant.AUTH_METHOD_MCP_SERVER.NONE_SETTING,
        Constant.AUTH_METHOD_MCP_SERVER.BEARER_SETTING,
        Constant.AUTH_METHOD_MCP_SERVER.APIKEY_SETTING
    ];
    // Backend → Frontend
    if (BACKEND_VALUES.includes(authMethod)) {
        const index = BACKEND_VALUES.indexOf(authMethod);
        return FRONTEND_VALUES[index];
    }

    // Frontend → Backend
    if (FRONTEND_VALUES.includes(authMethod)) {
        const index = FRONTEND_VALUES.indexOf(authMethod);
        return BACKEND_VALUES[index];
    }
};

const addPrefixForS3Key = (key, prefix = 'public/') => {
    if (!key) return '';
    key = key.startsWith(prefix) ? key : prefix + key;
    return key;
}

const removePrefixForS3Key = (key, prefix = 'public/') => {
    if (!key) return '';
    if (key.startsWith(prefix)) {
        return key.substring(prefix.length);
    }
    return key;
};

const isLatestUpdated = (obj, arr) => {
    if (!obj?.updatedAt) return false;
  
    const objTime = new Date(obj.updatedAt).getTime();
  
    // Tìm updatedAt lớn nhất trong mảng
    const maxTime = Math.max(...arr.map(item => new Date(item.updatedAt).getTime()));
  
    return objTime >= maxTime;
  }

const extractTitleAndContent = (textParam, options = {}) => {
    const regex = /\*\*(.+?)\*\*/;
    const match = textParam.match(regex);

    if (match) {
        let title = match[1] || '';
        let text = textParam.replace(match[0], '').trim();
        //unescape data, because data send from stream is escaped by Utils.escapeJSONSpecialCharacters
        title = unescapeJSONSpecialCharacters(title);
        text = unescapeJSONSpecialCharacters(text);
        return { title, text };
    } else {
        return { title: '', text: textParam };
    }
};

const unescapeJSONSpecialCharacters = (str) => {
    str = str.replace(/\\\\/g, '\\');     
    str = str.replace(/%\^&1/g, "'");
    str = str.replace(/\\n/g, '\n');
    str = str.replace(/\\\^\^/g, '"');
    return str;
}

const serverNameWithPrefix = (serverName, serverType, scope) => {
    let prefix = '';
    switch (serverType) {
        case Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR:
            prefix = '[CNN]';
            break;
        case Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL:
            prefix = '[PER]';
            break;
        case Constant.MCP_SERVER_TYPE.MCP_CATALOG:
            prefix = scope ? `${LOCAL_MCP_LABEL_PREFIX}${scope}` : LOCAL_MCP_LABEL_PREFIX;
            break;
        default:
            prefix = '[MCP]';
            break;
    }
    return `${prefix}${serverName}`
};

/**
 * Strip [MCP], [CNN], and [PER] prefix from MCP server field value
 * Example: "[CNN]APPLE,[MCP]PEAR,[PER]Dropbox" -> "APPLE,PEAR,Dropbox"
 */
const stripMcpPrefixFromValue = (value) => {
    if (typeof value === 'string' && value.trim().length > 0) {
        return value.split(',')
            .map(v => v.trim().replace(/^\[(MCP|CNN|PER)\]/, ''))
            .filter(v => v.length > 0)
            .join(',');
    }
    return value;
};

const isPhoneLikeString = (value) => {
    if (!value) return false;
    return /^[\d\s\-()+]+$/.test(value.trim());
};

const isValidPhoneNumber = (value) => {
    if (!value) return false;
    
    // Remove spaces, hyphens, and parentheses
    const cleaned = value.replace(/[\s\-\(\)]/g, '');
    
    // Check if it's a valid international phone number format (E.164)
    // Must start with + followed by country code and 10-15 total digits
    const phoneRegex = /^\+\d{10,15}$/;
    
    return phoneRegex.test(cleaned);
};

/**
 * isTrainingTicket
 * Checks if a telephone ticket is a training call by inspecting metaData.telephoneType
 * @param {Object} ticketDetail - Ticket detail object
 * @returns {boolean} true if the ticket is a training call
 */
const isTrainingTicket = (ticketDetail) => {
    if (!ticketDetail || isEmptyObject(ticketDetail)) return false;
    const metaData = convertJSONDataToObject(ticketDetail.metaData) || {};
    return metaData?.telephoneType === Constant.TICKET_PROPERTY.TRAINING;
};

/**
 * isAppIntegrationTicket
 * Checks if a telephone ticket is an App Integration call by inspecting metaData.telephoneType
 * @param {Object} ticketDetail - Ticket detail object
 * @returns {boolean} true if the ticket is an app integration call
 */
const isAppIntegrationTicket = (ticketDetail) => {
    if (!ticketDetail || isEmptyObject(ticketDetail)) return false;
    const metaData = convertJSONDataToObject(ticketDetail.metaData) || {};
    return metaData?.telephoneType === TelephoneConstant.METADATA_TELEPHONE_TYPE.APP_INTEGRATION;
};

/**
 * Determine voice call flow (who calls whom) from source and target IDs.
 * Returns a VOICE_CALL_FLOW value based on entity prefixes.
 */
const defineVoiceCallFlow = (ticketMeta) => {
    if (!ticketMeta) return TelephoneConstant.VOICE_CALL_FLOW.UNKNOWN;
    const metaData = convertJSONDataToObject(ticketMeta) || {};
    const from = Utils.getPrefixOfId(metaData?.from || '');
    const to = Utils.getPrefixOfId(metaData?.to || '');

    if (from === Constant.ID_PREFIX.PROJECT && to === Constant.ID_PREFIX.PROJECT) {
        return TelephoneConstant.VOICE_CALL_FLOW.PROJECT_TO_PROJECT;
    }

    if (from === Constant.ID_PREFIX.PROJECT && to === Constant.ID_PREFIX.USER) {
        return TelephoneConstant.VOICE_CALL_FLOW.PROJECT_TO_USER;
    }

    if (from === Constant.ID_PREFIX.USER && to === Constant.ID_PREFIX.PROJECT) {
        return TelephoneConstant.VOICE_CALL_FLOW.USER_TO_PROJECT;
    }

    return TelephoneConstant.VOICE_CALL_FLOW.UNKNOWN;
};

/**
 * Parse agent identity to extract projectId and userId
 * @param {string} agentIdentity - Format: "client:agent_project_xxx_user_xxx" or "agent_project_xxx_user_xxx"
 * @returns {{projectId: string, userId: string} | null} Parsed IDs or null if invalid
 */
const parseTwilioAgentIdentity = (agentIdentity) => {
    try {
        if (!agentIdentity) return null;
        let cleanIdentity = agentIdentity;
        if (agentIdentity.startsWith('client:')) {
            cleanIdentity = agentIdentity.replace('client:', '');
        }

        if (!cleanIdentity.startsWith('agent_')) {
            console.error('⚠️ Invalid agentIdentity format - must start with agent_:', agentIdentity);
            return null;
        }

        const withoutAgent = cleanIdentity.substring(6);
        
        const userIndex = withoutAgent.indexOf('_user_');
        
        if (userIndex === -1) {
            console.error('⚠️ Invalid agentIdentity format - missing _user_ separator:', agentIdentity);
            return null;
        }

        const projectId = withoutAgent.substring(0, userIndex);
        const userId = withoutAgent.substring(userIndex + 1);

        return { projectId, userId };
    } catch (error) {
        console.error('❌ parseAgentIdentity error:', {
            agentIdentity,
            error: error.message
        });
        return null;
    }
};

const isEnableUsingKBoard = corporationDetail => {
    if (isEmptyObject(corporationDetail)) return false;

    if (corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST) {
        return false;
    }

    const isUsingKBoard =
        corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
            ? convertJSONDataToObject(corporationDetail.inviterSetting)?.usingKBoard ===
                  Constant.STATUS_SERVICE_PERMISSION.ON &&
              convertJSONDataToObject(corporationDetail.inviterSetting)?.kBoard ===
                  Constant.STATUS_SERVICE_PERMISSION.ON
            : corporationDetail?.limitValue?.usingKBoard ===
                  Constant.STATUS_SERVICE_PERMISSION.ON &&
              corporationDetail?.limitValue?.kBoard === Constant.STATUS_SERVICE_PERMISSION.ON;

    return isUsingKBoard
};

/**
 * Block non half-width-digit characters on keypress for numeric-only inputs.
 * Prevents 'e', '-', '+', '.' and IME input (full-width alphanumeric, hiragana, full-width katakana).
 * @param {KeyboardEvent} evt
 */
const onKeyPressNumber = evt => {
    // Character e, -, + and .
    if ([69, 101, 109, 189, 173, 45].includes(evt.which) || !/[0-9]/.test(evt.key)) {
        evt.preventDefault();
    }
};

/**
 * Block pasting any text that contains non half-width-digit characters into numeric-only inputs.
 * @param {ClipboardEvent} e
 */
const handleOnPasteNumber = e => {
    const textInput = e.clipboardData.getData('Text');
    if (/[^0-9]/.test(textInput)) {
        e.preventDefault();
    }
};

const Utils = {
    cleanPhone,
    onKeyPressNumber,
    handleOnPasteNumber,
    parseTwilioAgentIdentity,
    defineVoiceCallFlow,
    serverNameWithPrefix,
    stripMcpPrefixFromValue,
    unescapeJSONSpecialCharacters,
    transformAuthMethod,
    normalizeFileData,
    isObjectType,
    isNotEmptyObj,
    isCorporationOnAI,
    isCorporationOnKBoardPrompt,
    isCorporationOnKnowledge,
    generateRandomStr,
    convertJSONDataToObject,
    getUrlParameter,
    readFileAsArrayBuffer,
    isEmptyObject,
    isEmptyString,
    isEmptyArray,
    getUserType,
    getTimeToDateNow,
    sortByCreatedAtDesc,
    sortByCreatedAtAsc,
    sortByUpdatedAtDesc,
    sortByUpdatedAtAsc,
    sortByDeletedAtAsc,
    sortByDrillDownLabelAsc,
    sortListByLabelDictionaryASC,
    sortByHitNumberDesc,
    isValidJSONString,
    isValidJSONObject,
    getCorporationIdFromContentId,
    getDateTimeByFormatJapanYYYY_MM_DDHHMM,
    getDateByFormatYYYY_MM_DD,
    reducerDataList,
    getGuestContractUrlParameter,
    isCreateGuestContractUrl,
    validateEmail,
    getMenuSelectedByUrl,
    isProjectManagerOfProject,
    getCloudFrontUrlForCorporationLogo,
    isEmpty,
    getValueString,
    getPrefixOfId,
    isApprovePageUrl,
    getTextByLanguage,
    isAdminUser,
    getFullNameOfUser,
    getFullNameOfUserWithActiveStatus,
    findIndexInArrayById,
    removeItemInArrayById,
    getCustomFieldValueInFormData,
    getFieldsValueEdited,
    validateURL,
    isSystemField,
    isTypeObject,
    isTypeFunction,
    getEditTicketData,
    isImageFile,
    getDateTimeByFormatYYYYMMDDHHMM,
    getDateTimeByFormatYYYYMMDDHHMMSS,
    formatIfDateTimeString,
    getPanelInfo,
    isLoginPageUrl,
    encodeDataByCrypto,
    decodeDataByCrypto,
    isAnonymousQATicket,
    isAnonymousQAWaitingTicket,
    isAnonymousQARejectTicket,
    isAnonymousQAApproveTicket,
    isDisableApproveRejectAnonymousQaTicket,
    isConfirmCreateOrgPageUrl,
    isConfirmCreateGuestOrgPageUrl,
    getUserStatus,
    getB2CStatusInProject,
    getShortName,
    formatStringUpperCaseFirstLetter,
    getUpdatedTimeTicket,
    isNotChangedName,
    replaceUrls,
    isJson,
    isExpired,
    setUpdatedTicketObject,
    normarlizeSearchKeyword,
    sortListByNameDictionaryASC,
    escapeHtmlCharacters,
    isPublicDesk,
    isPrivateDesk,
    isPublicOffDeskOff,
    isProjectGuest,
    isProjectGuestDesk,
    isGeneralUserWithoutGuest,
    isGeneralUser,
    isB2CUser,
    isGuestUser,
    isGuestContractType,
    findObjectById,
    sortListByNameCorpDictionaryASC,
    getPanelData,
    filterDuplicateItemsOfArray,
    checkArrayIncludesItem,
    removeDuplicateInArrayById,
    upperCaseFirstLetter,
    lowerCaseAllWordsExceptFirstLetters,
    compareTwoArraySorted,
    getUserNameWithActiveStatus,
    getCorporationName,
    getCorporationNameSuffixText,
    getFullNameOfUserWithCorporationStatus,
    getDisplayUserNameMsgVoice,
    getFileExtension,
    convertByteToGigaByte,
    updateNewDisplayNameOfProject,
    getTypeUser,
    handleRequest,
    getTitle,
    getDateTimeByFormatHHMM,
    sortListByTitle,
    getCloudFrontUrlOfFilePublicAll,
    sortListTagFieldOfCategory,
    sortCategoriesByOrder,
    generateChatBotScript,
    isAnonymousQATicketFromLiveChat,
    isAnonymousQALiveChatTicket,
    isAnonymousQAEndLiveChatTicket,
    isAnonymousQAExpireLiveChat,
    isAnonymousQAWaitingOrEndLiveChatTicket,
    isAnonymousLiveChatWaitingTicket,
    isAnonymousQAWaitingTicketFromLiveChat,
    initKeyFileSaveLogCreateTicketByUploadCsv,
    renderUploadKeys,
    getPaginatedItems,
    mappingLogStatusText,
    mappingLogMessageByStatus,
    mappingLogErrorList,
    genKeyFileCss,
    genKLRoboMsgConfigS3path,
    randomSubDomainCorporation,
    getUrlLinkCorporation,
    getUrlLinkCorporationSignedIn,
    getChatPermissionOfTicket,
    getUrlLinkShareLinkTicket,
    getUrlShortShareLinkTicket,
    getCurrentUrlCaseLogin,
    removeExcessZeros,
    convertDecimalNumber,
    sortListByOrderDesc,
    convertNumber,
    isNumber,
    areArraysEqual,
    getViewPermissionLabel,
    checkNumberDecimal,
    isDisabledTicketExternalWhenDeskServiceOff,
    checkUserPermissionKnowledgeService,
    getProjectName,
    sortDrillDownByNo,
    arraysHaveSameElements,
    isDisplaySplitPdfSwitch,
    isNumeric,
    convertLatinNumberToJapaneseFullWidthNumber,
    removeDigitsFromStringsArray,
    removeLatinAndJapaneseFullwidthNumbers,
    isJapaneseFullwidthNumber,
    convertJapaneseFullWidthNumberToLatinNumber,
    isNameOrUrlOfPdfFile,
    isUsingFunctionService,
    setDefaultPermissionForSynonymForm,
    validateSizeOfFieldTicket,
    validateSizeOfS3TextField,
    isValidLinkPromptInput,
    getTicketIdFromSharedLink,
    destructLinkPrompt,
    createTagForLogKibana,
    mappingLogSuccessList,
    renderLogStatusText,
    renderLogMessage,
    renderLogListItem,
    validateStyleSheet,
    getShareLinkUrls,
    convertByteToMB,
    splitArrayIntoSubArrays,
    sortByExecuteTimeAtDesc,
    getUniqueObjectListInArray,
    filterDuplicates,
    initKeyFileSaveLogBulkAction,
    isAnonymousQALiveChatDeleted,
    isAnonymousQATicketFromChatBotAndFinish,
    isAnonymousQATicketFromIframe,
    isStringOverLength,
    getCurrentDevice,
    isMobileOrTabletDevice,
    delay,
    sortListBookmarkByNameASC,
    getArrByBreakline,
    validIpAddressFormat,
    isNumberExludeStartZero,
    findDuplicateData,
    detectUrlType,
    removeExtraCharactersOfIdTicket,
    isEnableCreateEmailTicketMode,
    isEnableSettingTelephoneAgent,
    chunkArray,
    getEmailDomain,
    giveBackHtmlCharacters,
    isEnableCreateEmailTicketModeOnSkipProjectType,
    validateEmailVer2,
    isDisableEditEmailTicket,
    unEscapeHtml,
    isSystemFormChatAIPrompt,
    removeDoubleQuotes,
    isSystemAIAutoForm,
    isCorporationOnAIAuto,
    isCorporationOnSDAuto,
    validateDateByMinutesStep,
    getUserEmailAfterDeleted,
    getDisplayUserEmailWithoutSuffix,
    handlePreviewHtmlSource,
    buildHtmlFieldValueS3Key,
    buildJsonFieldValueS3Key,
    buildHtmlShareLinkPage,
    cleanHtml,
    putFieldDataToS3BeforeEditTicket,
    getRichTextUrls,
    getKeyFileFromCDNLinks,
    isGroupQATicketType,
    getJSTDateTimeYYYY_MM_DDHHMM,
    convertTimeToLocalYYYY_MM_DD_HH_MM_SS,
    getUrlLinkShareLinkChatPost,
    extractShareLinkInfo,
    getBookmarkTargetTypeByTicketType,
    buildScriptFieldValueS3Key,
    buildMarkdownFieldValueS3Key,
    isSystemSDAutoForm,
    isSystemTelephoneForm,
    isProjectOnPhoneSupport,
    isBase62,
    isShortShareLink,
    isShortLinkAttachFile,
    getTicketIdByShareLink,
    generateS3LinkCodeSDScript,
    isValidAlphaNumericUnderscore,
    isValidUrl,
    setFocusedMsgId,
    parseDate,
    isCorporationOnMfa,
    formatBytes,
    isInternalUser,
    generateAttachmentShareLink,
    isSystemAIAutoEventForm,
    getShareLinkImg,
    getThumbnailPaths,
    isEqualArray,
    addPrefixForS3Key,
    removePrefixForS3Key,
    isLatestUpdated,
    extractTitleAndContent,
    isSystemBusinessAppForm,
    countCharacters,
    isSystemTelephoneAgentForm,
    isSystemKBoardKnowledgeForm,
    isProjectOnTelephoneSupport,
    isSystemFormAITelephonePrompt,
    isSystemFormAIAssistantPrompt,
    isSystemFormAITrainingPrompt,
    isSystemFormKBoardPrompt,
    isFakePhoneUserEmail,
    isValidPhoneNumber,
    isPhoneLikeString,
    shouldShowPhoneIcon,
    isDisplayHelpdeskTicketList,
    getUserNameInDrilldown,
    addPlusToPhoneNumber,
    isEnableUsingTelephoneMode,
    isProjectOnExternalPhoneCall,
    isEnableExternalPhoneCall,
    isTrainingTicket,
    isAppIntegrationTicket,
    isProjectDeskOn,
    isEnabledServiceValue,
    getLinkDownloadFileFromS3,
    isEnableUsingKBoard,
    formatDateTime
};

export default Utils;
